{
  "account": {
    "title": "Ο λογαριασμός μου",
    "list": {
      "title": "Λογαριασμοί",
      "description": "Κατάλογος τιμολογίων συνδεδεμένων λογαριασμών"
    },
    "form": {
      "name": {
        "title": "Όνομα",
        "description": "Το όνομα του λογαριασμού σας"
      },
      "password": {
        "title": "Κωδικός πρόσβασης",
        "description": "Ορίστε νέο κωδικό για τον λογαριασμό σας· αφήστε κενό για διατήρηση του τρέχοντος κωδικού"
      },
      "emailPreferences": {
        "title": "Προτιμήσεις email",
        "description": "Επιλέξτε τύπους ειδοποιήσεων email"
      }
    },
    "billing": "Στοιχεία τιμολόγησης",
    "subscriptions": "Συνδρομές",
    "manageSubscription": "Διαχείριση συνδρομής",
    "popup": {
      "cancel": "Είστε βέβαιοι ότι θα ακυρώσετε τη συνδρομή σας; <br/>Ο ιστότοπός σας θα συνεχίσει να μεταφράζεται μέχρι το τέλος της τρέχουσας περιόδου. Στη συνέχεια, η μετάφραση θα απενεργοποιηθεί.<br/>Παρακαλούμε σημειώστε ότι δεν θα δικαιούστε επιστροφή χρημάτων για την αδιάθετη περίοδο.",
      "downgrade": "Είστε βέβαιοι για την υποβάθμιση; Η υποβάθμιση θα ισχύσει άμεσα.<br/>Παρακαλούμε σημειώστε ότι δεν θα δικαιούστε επιστροφή χρημάτων για τον υπολειπόμενο χρόνο του τρέχοντος κύκλου τιμολόγησης.<br/>Η νέα τιμή του πλάνου θα εφαρμοστεί στον επόμενο κύκλο τιμολόγησης.",
      "default": "Είστε βέβαιοι ότι θέλετε να αλλάξετε πλάνο;",
      "resume": "Είστε σίγουροι ότι θέλετε να συνεχίσετε τη συνδρομή σας;"
    }
  },
  "ai_translation": {
    "header": "Μετάφραση AI",
    "plan": {
      "header": "Τιμολόγηση μετάφρασης AI",
      "used": "Έχετε χρησιμοποιήσει {words_used} / {words_allowed} λέξεις μετάφρασης στα πιστωτικά σας AI.",
      "remaining": "Διαθέσιμα πιστωτικά AI:",
      "words": "λέξεις",
      "add_more_credits": "Προσθέστε περισσότερα πιστωτικά AI",
      "details": {
        "idiomatic_expressions": "Ιδιωματικές και τεχνικές εκφράσεις",
        "background_translation": "Μεταφράσεις στο παρασκήνιο",
        "best_website": "Ιστότοποι που απαιτούν τέλεια ποιότητα μετάφρασης",
        "page_context": "Συναφή περιεχόμενα σελίδας και ιστότοπου για μετάφραση",
        "perfect_quality": "Τέλεια ποιότητα, προσιτή τιμή",
        "no_recurring": "Χωρίς επαναλαμβανόμενες πληρωμές, προπληρωμένο όριο",
        "save_40": "Εξοικονομήστε 40% σε σύγκριση με το πλάνο των 20 $",
        "save_50": "Εξοικονομήστε 50% σε σύγκριση με το πλάνο των 20 $"
      },
      "quota": "{estimated_words} λέξεις ~ {estimated_pages} σελίδες"
    },
    "settings": {
      "banner": {
        "title": "Μετάφραση AI Linguise",
        "intro": "Η Linguise παρουσιάζει με ενθουσιασμό τη Μετάφραση AI Linguise, ένα νέο premium χαρακτηριστικό που αξιοποιεί μοντέλα AI LLM (τα πιο πρόσφατα μοντέλα Llama, βελτιστοποιημένα για μεταφράσεις). Σχεδιασμένο για ιστότοπους που απαιτούν άριστη ακρίβεια, λαμβάνει υπόψη το πλαίσιο τόσο της σελίδας όσο και ολόκληρου του ιστότοπου για ασύγκριτα αποτελέσματα. Προσφέρετε στους πελάτες σας την κορυφαία ποιότητα μετάφρασης, διασφαλίζοντας ότι το μήνυμά τους αντηχεί τέλεια σε κάθε γλώσσα.",
        "button": "Αναβαθμίστε τώρα"
      },
      "alert": {
        "description": "Αυτό το χαρακτηριστικό δεν περιλαμβάνεται στο τρέχον πλάνο σας και απαιτεί ξεχωριστή αγορά.\nΕνεργοποιήστε αυτό το πρόσθετο για να ξεκλειδώσετε όλες τις παρακάτω επιλογές."
      },
      "languages": {
        "title": "Εφαρμογή μετάφρασης AI σε γλώσσες",
        "description": "Επιλέξτε συγκεκριμένες γλώσσες όπου θέλετε να εφαρμοστεί η μετάφραση AI"
      },
      "button": {
        "save": "Αποθήκευση ρυθμίσεων"
      },
      "form": {
        "advanced": {
          "title": "Προηγμένες οδηγίες AI",
          "description": "Προηγμένες οδηγίες AI"
        },
        "enable_mode": {
          "title": "ΕΝΕΡΓΟΠΟΊΗΣΗ ΜΕΤΆΦΡΑΣΗΣ AI",
          "description": "Επιλέξτε πώς θα ενεργοποιηθεί η μετάφραση AI.\nΜόνο κανόνες θα εφαρμόσει τους παρακάτω κανόνες.\nΜόνο live editor θα επιτρέπει την ενεργοποίηση μετάφρασης ανά σελίδα από την προβολή live editor.\nΚανόνες και live editor θα χρησιμοποιήσουν και τα δύο χαρακτηριστικά.",
          "disabled": "Απενεργοποιημένη",
          "rules": "Μόνο κανόνες",
          "live_editor": "Μόνο live editor",
          "all": "Κανόνες και live editor"
        },
        "rule_application": {
          "description": "Εφαρμογή της Μετάφρασης AI σε στατικό ή δυναμικό περιεχόμενο ή και στα δύο",
          "title": "Εφαρμογή σε περιεχόμενο",
          "all": "Όλο το περιεχόμενο",
          "static": "Στατικό περιεχόμενο",
          "dynamic": "Δυναμικό περιεχόμενο"
        },
        "website_topic": {
          "title": "Θέμα ιστότοπου",
          "placeholder": "Εστιατόριο σούσι...",
          "description": "Ορίστε το θέμα του ιστότοπού σας για καλύτερη ποιότητα μετάφρασης (π.χ. Νομικά, εστιατόριο σούσι, κατάστημα ανταλλακτικών ποδηλάτων…)\nΠαρακαλούμε εισάγετε το θέμα του ιστότοπου στα Αγγλικά."
        },
        "apply_to_urls": {
          "title": "Εφαρμογή σε URLs",
          "description": "Επιλέξτε συγκεκριμένα URLs όπου θέλετε να εφαρμοστεί η μετάφραση AI",
          "all_urls": "Όλα τα URLs",
          "selected_urls": "Επιλεγμένα URLs",
          "label": "URL για εφαρμογή",
          "placeholder": "URL για εφαρμογή",
          "wildcard": "Χαρακτήρας υποκατάστασης",
          "regex": "Κανονική έκφραση",
          "add": "Προσθήκη νέου",
          "expression": "Τύπος έκφρασης"
        },
        "apply_languages": {
          "title": "Εφαρμογή σε γλώσσες",
          "description": "Επιλέξτε συγκεκριμένες γλώσσες όπου θέλετε να εφαρμοστεί η μετάφραση AI",
          "all_languages": "Όλες οι γλώσσες",
          "selected_languages": "Επιλεγμένες γλώσσες",
          "placeholder": "Επιλέξτε γλώσσες...",
          "feedback": "Πρέπει να επιλέξετε μία γλώσσα"
        },
        "formality": {
          "title": "Επισημότητα",
          "description": "Καθορίστε το επίπεδο επισημότητας στις μεταφράσεις, πιθανώς σημαντικό για κοινό και συγκείμενα.\nΤο \"Ουδέτερο\" θα προσπαθήσει να διατηρήσει την αρχική επισημότητα του περιεχομένου.\nΤο \"Επίσημο\" αφορά επαγγελματικό, επιχειρηματικό ή νομικό περιεχόμενο (π.χ. χρήση επίσημων αντωνυμιών όπως \"usted\" στα Ισπανικά).\nΤο \"Ανεπίσημο\" αφορά χαλαρό, συνομιλητικό περιεχόμενο (π.χ. χρήση του \"tú\" στα Ισπανικά).",
          "neutral": "Ουδέτερο",
          "formal": "Επίσημο",
          "informal": "Ανεπίσημο"
        },
        "sentence_structure": {
          "classic": "Κλασικό",
          "short": "Μικρές και γρήγορες προτάσεις",
          "detailed": "Λεπτομερείς και επεξηγηματικές προτάσεις",
          "title": "Δομή πρότασης",
          "description": "Καθορίστε την προτίμηση γραφής."
        },
        "content_purpose": {
          "marketing": "Μάρκετινγκ/προωθητικό (πειστικός, ελκυστικός τόνος)",
          "technical": "Τεχνικό/ενδεικτικό (σαφές, ακριβές, προσανατολισμένο σε ενέργειες)",
          "support": "Υποστήριξη πελατών (συμπονετικός, βοηθητικός, καθησυχαστικός)",
          "legal": "Νομικό/συμμόρφωση (ακριβές, επίσημο, αδιαμφισβήτητο)",
          "educational": "Εκπαιδευτικό (σαφές, δομημένο, προσβάσιμο)",
          "other": "Άλλο (στα Αγγλικά)",
          "title": "Σκοπός περιεχομένου",
          "description": "Καθορίστε τον λειτουργικό σκοπό του περιεχομένου προς μετάφραση.",
          "other_placeholder": "Περιγράψτε τον σκοπό..."
        },
        "target_audience": {
          "title": "Στόχευση κοινού",
          "description": "Προσδιορισμός του προβλεπόμενου κοινού του μεταφρασμένου περιεχομένου (στα Αγγλικά).",
          "placeholder": "π.χ., ισπανόφωνοι γονείς, υπεύθυνοι απορρήτου της ΕΕ"
        },
        "override_default_translations": {
          "title": "Αντικατάσταση προεπιλεγμένης μετάφρασης",
          "description": "Αν οριστεί σε ΝΑΙ, αυτή η επιλογή θα αναγκάσει το περιεχόμενο να μεταφραστεί με AI (Linguise AI) ακόμα και αν έχει ήδη μεταφραστεί από το μοντέλο Cloud AI (προεπιλεγμένο μοντέλο μετάφρασης)."
        },
        "force_replace_before": {
          "title": "Εξαναγκασμός νέας μετάφρασης AI",
          "description": "Μεταφράστε ξανά με AI κάθε περιεχόμενο του οποίου η μετάφραση AI δημιουργήθηκε πριν από την επιλεγμένη ημερομηνία — για παράδειγμα, περιεχόμενο που μεταφράστηκε με παλαιότερο μοντέλο. Η νέα μετάφραση θα γίνει στην επόμενη επίσκεψη των σχετικών σελίδων, σύμφωνα με τους κανόνες, και θα χρησιμοποιήσει τις μονάδες AI σας.",
          "before_date": "Πριν από ημερομηνία"
        },
        "model": {
          "current": "Τρέχον",
          "title": "Μοντέλο",
          "description": "Επιλέξτε το μοντέλο μετάφρασης LLM που θέλετε να χρησιμοποιήσετε",
          "load_error": "Αδυναμία φόρτωσης διαθέσιμων μοντέλων. Δοκιμάστε ξανά αργότερα.",
          "thinking_warning": "Αυτό το μοντέλο χρησιμοποιεί υψηλό επίπεδο συλλογισμού (\"σκέψη\") και θα καταναλώσει σημαντικά περισσότερα tokens ανά μετάφραση."
        },
        "override_manual_and_selected": {
          "no_default": "Όχι (προεπιλογή)",
          "title": "Αντικατάσταση χειροκίνητων και επιλεγμένων μεταφράσεων",
          "description": "Από προεπιλογή, μια μετάφραση που επεξεργαστήκατε χειροκίνητα παραμένει πάντα στον ιστότοπό σας, ακόμη και μετά τη δημιουργία βελτιωμένης μετάφρασης AI. Επιλέξτε «Ναι» για να εμφανίζεται αντί αυτής η βελτιωμένη μετάφραση AI. Οι χειροκίνητες μεταφράσεις σας διατηρούνται και μπορείτε να επιστρέψετε ανά πάσα στιγμή. Αυτό ισχύει επίσης όταν μεταφράζετε ξανά τις σελίδες για να λάβετε νέες μεταφράσεις· θα χρησιμοποιείται αυτόματα η πιο πρόσφατη."
        }
      },
      "message": {
        "save_success": "Από το ήδη μεταφρασμένο περιεχόμενο, ο αριθμός των σελίδων που θα βελτιωθούν με μετάφραση AI είναι περίπου {{ai_affected_urls}}.",
        "save_success_only": "Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς."
      }
    },
    "pricing": {
      "plan": {
        "title": "Παραγγελία ορίου μετάφρασης AI",
        "buy_button": "ΑΓΟΡΑ ΠΑΚΕΤΟΥ ΜΕΤΑΦΡΑΣΗΣ AI"
      },
      "modal": {
        "title": "Επιβεβαίωση αλλαγής πλάνου",
        "description": "Είστε βέβαιοι ότι θέλετε να αλλάξετε το πλάνο Μετάφρασης AI σας;",
        "button_cancel": "Ακύρωση",
        "button_confirm": "Επιβεβαίωση",
        "loading": "Παρακαλώ περιμένετε...",
        "amount": "Ποσό",
        "credit": "Πίστωση",
        "total_due": "Συνολικό ποσό οφειλής"
      },
      "comparison": {
        "title": "Google Cloud AI μετάφραση\nvs Linguise AI μετάφραση",
        "list": {
          "0": {
            "google": "Γρήγορες και αξιόπιστες μεταφράσεις",
            "linguise": "Διαχειρίζεται ιδιωματισμούς και τεχνικούς όρους"
          },
          "1": {
            "google": "Άμεση μετάφραση όλων των σελίδων του ιστότοπου",
            "linguise": "Δημιουργία μεταφράσεων στο παρασκήνιο"
          },
          "2": {
            "google": "Καλύτερη ποιότητα, χαμηλή τιμή",
            "linguise": "Τέλεια ποιότητα, προσιτή τιμή"
          },
          "3": {
            "google": "Ιδανικό για μεγάλους ιστότοπους ή περιορισμένο προϋπολογισμό",
            "linguise": "Ιδανικό για ιστότοπους που απαιτούν τέλεια ποιότητα μετάφρασης"
          },
          "4": {
            "google": "Συναφής σελίδα για τη μετάφραση",
            "linguise": "Συναφής σελίδα και ιστότοπος για τη μετάφραση"
          }
        }
      },
      "botom_banner": {
        "title": "Βιώστε Ασύγκριτη Ακρίβεια Μετάφρασης με το",
        "sub_title": "Νέο Linguise AI Translation",
        "description": "Η Linguise ενισχύει τις υπηρεσίες αυτόματης μετάφρασης με την εισαγωγή του Linguise AI Translation, μια ισχυρή νέα επιλογή που χρησιμοποιεί προηγμένο AI LLM μετάφρασης (τα πιο πρόσφατα μοντέλα Llama βελτιστοποιημένα για μεταφράσεις). Αυτή η προσθήκη παρέχει στους προγραμματιστές ιστοσελίδων και στις διαδικτυακές εταιρείες ένα ακόμα υψηλότερο επίπεδο ποιότητας μετάφρασης, ιδανικό για έργα όπου η τελειότητα είναι ζωτικής σημασίας. Το Linguise AI Translation συμπληρώνει την υπάρχουσα υψηλής ποιότητας Google Cloud AI μετάφρασή μας, προσφέροντας μεγαλύτερη ευελιξία και ακρίβεια."
      }
    },
    "success": {
      "tab_title": "Ευχαριστούμε για την αγορά του πλάνου AI Translation!",
      "title": "Ευχαριστούμε για την αγορά του πλάνου AI Translation!",
      "subtitle": "Το πλάνο AI Translation σας αγοράστηκε με επιτυχία!",
      "message": "Μπορείτε να διαχειριστείτε το πλάνο AI Translation σας στη σελίδα ρυθμίσεων του AI Translation.",
      "home": "Διαχείριση AI Translation"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Όνομα",
        "description": "Όνομα λογαριασμού χρέωσης"
      },
      "phone": {
        "title": "Τηλέφωνο",
        "description": "Τηλέφωνο λογαριασμού χρέωσης"
      },
      "email": {
        "title": "Email",
        "description": "Email λογαριασμού χρέωσης"
      },
      "address": {
        "title": "Διεύθυνση",
        "description": "Διεύθυνση λογαριασμού χρέωσης",
        "city": "Πόλη",
        "country": "Χώρα",
        "address1": "Διεύθυνση 1",
        "address2": "Διεύθυνση 2",
        "postal": "Ταχυδρομικός κώδικας",
        "state": "Πολιτεία"
      },
      "tax": {
        "title": "ΑΦΜ"
      }
    }
  },
  "checkouts": {
    "header": "Ταμείο",
    "payment_method": "Επιλογή Τρόπου Πληρωμής",
    "stripe_card": "Πιστωτική κάρτα (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Εισαγωγή νέας διεύθυνσης χρέωσης",
      "existing": "Χρήση υπάρχουσας διεύθυνσης"
    },
    "pay_stripe": "Επιβεβαίωση και πληρωμή",
    "terms": "Με την επιβεβαίωση της συνδρομής σας, επιτρέπετε στη Linguise να σας χρεώνει για μελλοντικές πληρωμές σύμφωνα με τους όρους μας. Μπορείτε πάντα να ακυρώσετε τη συνδρομή σας.",
    "coupon": {
      "title": "Έχετε κουπόνι;",
      "placeholder": "Εισάγετε τον κωδικό κουπονιού εδώ",
      "apply": "Εφαρμογή",
      "percent": "Έκπτωση {{0}}%"
    },
    "add_new": "Προσθήκη νέου",
    "use_existing": "Χρήση υπάρχοντος τρόπου πληρωμής",
    "recurring": {
      "month_single": "Χρέωση κάθε μήνα",
      "month_many": "Χρέωση κάθε {{count}} μήνες",
      "year_single": "Χρέωση κάθε χρόνο",
      "year_many": "Χρέωση κάθε {{count}} χρόνια",
      "day_single": "Χρέωση καθημερινά",
      "day_many": "Χρέωση κάθε {{count}} ημέρες",
      "week_single": "Χρέωση κάθε εβδομάδα",
      "week_many": "Χρέωση κάθε {{count}} εβδομάδες"
    },
    "add_new_no_stripe": "Προσθήκη νέας κάρτας",
    "summary": {
      "title": "Σύνοψη",
      "subtotal": "Υποσύνολο",
      "total": "Σύνολο"
    }
  },
  "dashboard": {
    "main": {
      "title": "Ταμπλό"
    },
    "statistics": {
      "main_title": "Στατιστικά τελευταίων 30 ημερών",
      "characters": "Μεταφρασμένοι χαρακτήρες",
      "words": "Μεταφρασμένες λέξεις",
      "bandwidth": "Εισερχόμενο εύρος ζώνης",
      "request": "Αιτήματα",
      "page_views": "Προβολές σελίδων ανά γλώσσα (τελευταίες 30 ημέρες)",
      "multilingual_views": "Πολύγλωσσες προβολές σελίδων (τελευταίες 30 ημέρες)",
      "most_page_viewed": "20 Πιο προβεβλημένες σελίδες (τελευταίες 30 ημέρες)",
      "no_data_yet": "Δεν υπάρχουν διαθέσιμα δεδομένα ακόμα",
      "th_language": "Γλώσσα",
      "th_page_views": "Προβολές σελίδων",
      "real_visitors": "Πραγματικοί επισκέπτες",
      "crawler": "Crawler"
    },
    "planHints": {
      "subscribeButton": "Εγγραφή",
      "upgradeButton": "Αναβάθμιση",
      "usedWords": "Αυτή τη στιγμή χρησιμοποιείτε {words_used} λέξεις",
      "noPlan": "Δεν έχει ενεργοποιηθεί πλάνο για αυτόν τον τομέα. Εγγραφείτε σε πλάνο και αρχίστε να μεταφράζετε τον ιστότοπό σας",
      "noPlanShopify": "Δεν έχει ενεργοποιηθεί πλάνο για αυτόν τον τομέα. Εγγραφείτε σε πλάνο από το ταμπλό Shopify σας και αρχίστε να μεταφράζετε τον ιστότοπό σας",
      "trialUsage": "Αυτή τη στιγμή χρησιμοποιείτε {words_used} λέξεις από τις {words_allowed} λέξεις που περιλαμβάνονται στο δοκιμαστικό πλάνο.",
      "trialEnds": "Η δοκιμαστική περίοδος ενός μήνα ενεργοποιείται μέχρι τις {trial_ends}.",
      "subscribeMessage": "Εγγραφείτε πριν ολοκληρωθεί για να κρατήσετε μεταφρασμένο τον ιστότοπό σας",
      "subscribeMessageShopify": "Εγγραφείτε από το ταμπλό Shopify σας πριν ολοκληρωθεί για να κρατήσετε μεταφρασμένο τον ιστότοπό σας",
      "trialReachedLimit": "Έχετε φτάσει το μέγιστο αριθμό λέξεων για την περίοδο δοκιμής.\nΕγγραφείτε σε ένα από τα πλάνα μας για να συνεχίσετε να μεταφράζετε τον ιστότοπό σας.",
      "paidUsage": "Έχετε χρησιμοποιήσει {words_used} / {words_allowed} λέξεις μετάφρασης στο πλάνο σας.",
      "paidReachedLimit": "Έχετε φτάσει το μέγιστο αριθμό λέξεων για το τρέχον πλάνο.\nΑναβαθμίστε το πλάνο σας για να συνεχίσετε να μεταφράζετε το περιεχόμενο του ιστότοπου.",
      "trialOfferedUsage": "Αυτή τη στιγμή χρησιμοποιείτε {words_used} λέξεις από τις {words_allowed} λέξεις που περιλαμβάνονται στο δοκιμαστικό πλάνο.(Συμπεριλαμβανομένων των {free_words} προσφερόμενων λέξεων)",
      "paidOfferedUsage": "Έχετε χρησιμοποιήσει {words_used} / {words_allowed} λέξεις μετάφρασης στο πλάνο σας.(Συμπεριλαμβανομένων των {free_words} προσφερόμενων λέξεων)",
      "noPlanExtra": "Λάβετε υπόψη ότι οι ανενεργοί τομείς και τα δεδομένα τους διαγράφονται τακτικά αυτόματα.",
      "planRecommended": "Βάσει του τρέχοντος όγκου μετάφρασής σας, το προτεινόμενο πλάνο είναι:",
      "planMaximumWords": "{{words}} λέξεις",
      "notHaveTranslatedWords": "Δεν έχετε πραγματοποιήσει καμία μετάφραση ακόμα"
    },
    "translationSetup": {
      "kicker": "ΡΥΘΜΙΣΗ SUBDOMAIN",
      "title": "Έλεγχος ρύθμισης μετάφρασης",
      "description": "Ελέγξτε το DNS, τους μεταφρασμένους κεντρικούς υπολογιστές, την πρόσβαση στον αρχικό ιστότοπο και τα όρια λογαριασμού.",
      "starting": "Γίνεται έλεγχος...",
      "button": "Έλεγχος ρύθμισης",
      "viewLatest": "Προβολή τελευταίου αποτελέσματος",
      "viewCurrent": "Προβολή τρέχοντος ελέγχου",
      "runAgain": "Εκ νέου εκτέλεση ελέγχου",
      "viewDetails": "Προβολή λεπτομερειών",
      "hideDetails": "Απόκρυψη λεπτομερειών",
      "error": "Δεν είναι δυνατός ο έλεγχος της ρύθμισης",
      "allPassed": "Όλοι οι έλεγχοι πέρασαν",
      "setupNeedsAttention": "Η ρύθμιση χρειάζεται προσοχή",
      "setupNeedsAttentionDescription": "Ένας ή περισσότεροι έλεγχοι απέτυχαν. Ελέγξτε τα παρακάτω στοιχεία ή επικοινωνήστε με την υποστήριξη Linguise.",
      "lastChecked": "Τελευταίος έλεγχος {{time}}",
      "domainOwnership": "Ιδιοκτησία domain",
      "domainOwnershipDescription": "Βρέθηκε εγγραφή επαλήθευσης",
      "domainOwnershipFailure": "Δεν ήταν δυνατή η επαλήθευση της εγγραφής DNS ιδιοκτησίας.",
      "translatedHosts": "Μεταφρασμένοι hosts",
      "translatedHostsDescription": "Ελέγχθηκαν {{count}} γλωσσικοί hosts",
      "translatedHostsFailure": "Μία ή περισσότερες εγγραφές CNAME γλωσσών είναι λανθασμένες.",
      "subdomainPage": "Σελίδα subdomain",
      "subdomainPageDescription": "{{count}} μεταφρασμένες σελίδες δέχονται HTTPS",
      "subdomainPageFailure": "Η σύνδεση TLS απέτυχε κατά το άνοιγμα μίας ή περισσότερων μεταφρασμένων σελίδων.",
      "originalSite": "Αρχικός ιστότοπος",
      "originalSiteDescription": "Έλεγχοι DNS, TLS και απόκρισης αρχικού ιστότοπου",
      "originalSiteFailure": "Ο έλεγχος DNS, TLS ή απόκρισης του αρχικού ιστότοπου απέτυχε.",
      "documentationAdvice": {
        "dns": "Έλεγχος ρύθμισης DNS",
        "tls": "Έλεγχος ρύθμισης HTTPS",
        "origin": "Έλεγχος ρύθμισης αρχικού ιστότοπου",
        "diagnostic": "Ελέγξτε τα βήματα αντιμετώπισης προβλημάτων"
      },
      "evidence": {
        "originDns": "Αρχικό DNS",
        "originTls": "Αρχικό TLS",
        "originHttp": "Απόκριση αρχικού ιστότοπου",
        "observedTargets": "Εντοπισμένοι προορισμοί",
        "recordCount": "Εγγραφές που βρέθηκαν",
        "addressCount": "Διευθύνσεις που βρέθηκαν",
        "statusCode": "Κατάσταση HTTP",
        "redirect": "Ανακατεύθυνση",
        "expiresAt": "Λήξη πιστοποιητικού",
        "raw": "{{key}}",
        "noValue": "Χωρίς τιμή"
      },
      "checkerError": "Δεν ήταν δυνατή η ολοκλήρωση ορισμένων ελέγχων.",
      "coreLocation": "Έλεγχος από {{location}}",
      "status": {
        "queued": "Σε αναμονή",
        "running": "Εκτελείται",
        "completed": "Ολοκληρώθηκε",
        "failed": "Απέτυχε",
        "passed": "Επιτυχής",
        "warning": "Προειδοποίηση",
        "unknown": "Άγνωστο",
        "skipped": "Παραλείφθηκε",
        "not_applicable": "Δεν εφαρμόζεται"
      }
    },
    "throttling": {
      "title": "Περιορισμός μετάφρασης",
      "description": "Προσωρινά όρια χρήσης",
      "unavailable": "Τα προσωρινά όρια μετάφρασης δεν είναι διαθέσιμα",
      "window": "{{used}} / {{max}} λέξεις",
      "resetsIn": "Επαναφορά σε {{time}}",
      "throttled": "Η μετάφραση έχει τεθεί προσωρινά σε παύση",
      "throttledDescription": "Έχει επιτευχθεί ένα προσωρινό όριο χρήσης. Η μετάφραση θα συνεχιστεί όταν γίνει επαναφορά αυτού του χρονικού διαστήματος."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "ΒΗΜΑ {{step}} ΑΠΟ {{total}}",
      "doneLabel": "ΟΛΟΚΛΗΡΩΘΗΚΕ, ΜΠΟΡΕΙΤΕ ΝΑ ΞΕΚΙΝΗΣΕΤΕ ΤΗ ΜΕΤΑΦΡΑΣΗ!",
      "finish": {
        "title": "",
        "description": "Αυτό είναι το κλειδί API για χρήση στον ιστότοπό σας"
      },
      "instructions": "Οδηγίες εγκατάστασης",
      "domainSetting": "Ρύθμιση τομέα",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Σενάριο PHP",
        "wizardWordpressStep1": "1. Εγκαταστήστε το ",
        "wizardWordpressStep2": "\n 2. Στις ρυθμίσεις του plugin αντιγράψτε και συμπληρώστε το κλειδί API\n",
        "wizardWordpressStep3": "3. Είστε έτοιμοι να μεταφράσετε\n\n",
        "wizardWordpressStep4": "Για πιο λεπτομερείς οδηγίες, παρακαλούμε συμβουλευτείτε την τεκμηρίωσή μας: ",
        "wizardJoomlaStep1": "1. Σύνδεσμος πακέτου Joomla: ",
        "wizardJoomlaStep2": "\n2. Στις ρυθμίσεις της επέκτασης, αντιγράψτε και συμπληρώστε το κλειδί API σας",
        "wizardJoomlaStep3": "3. Στη διαμόρφωση της ενότητας, ορίστε τις γλώσσες που θέλετε να εμφανίζονται και τοποθετήστε την ενότητα όπου τη χρειάζεστε.",
        "wizardJoomlaStep4": "\n 4. Είστε έτοιμοι να μεταφράσετε\n\n",
        "wizardPhpStep1": "1. Κατεβάστε το php script μας και εδώ ",
        "wizardPhpStep2": "\n2. Ακολουθήστε τις οδηγίες εγκατάστασης στη σελίδα τεκμηρίωσής μας εδώ ",
        "wizardPhpStep3": "\n3. Προσθέστε την ενότητα στις σελίδες σας.",
        "wizardPhpStep4": "\n Αντιγράψτε τον παρακάτω κώδικα και προσθέστε τον στην κεφαλίδα της html σελίδας σας για να εμφανίζεται αυτόματα η ενότητα διακόπτη\n",
        "dispatchStep1": "Στείλαμε με επιτυχία τα απαραίτητα δεδομένα στο πρόσθετο Linguise, μπορείτε πλέον να κλείσετε το παρακάτω παράθυρο.",
        "dispatchStep2": "Σε περίπτωση που λείπει το token όταν κλείσετε αυτό το παράθυρο, παρακαλούμε αντιγράψτε το ακόλουθο token:",
        "dispatchStep3": "Μπορείτε επίσης να αντιγράψετε αυτό το απόσπασμα για να ενεργοποιήσετε αυτόματα το διακόπτη σημαίας μας",
        "wizardOtherStep1": "Ακολουθήστε τις παρακάτω οδηγίες για να εγκαταστήσετε το Linguise στο domain σας.\n",
        "wizardOtherStep2": "Αντιγράψτε τον παρακάτω κώδικα και προσθέστε τον στην κεφαλίδα της html σελίδας σας· θα εμφανίζεται αυτόματα η ενότητα διακόπτη.\n"
      },
      "trialAlreadyUsed": "Φαίνεται πως έχετε ήδη χρησιμοποιήσει τη δωρεάν δοκιμή σας, οπότε χρειάζεται να προμηθευτείτε ποσόστωση μετάφρασης\nΠαρακαλούμε εγγραφείτε σε κάποιο πλάνο ή επικοινωνήστε μαζί μας για να επεκτείνετε τη δοκιμή σας.",
      "usefulLinks": "Χρήσιμοι σύνδεσμοι για να ξεκινήσετε",
      "linkDocumentation": "Τεκμηρίωση",
      "linkExtensionDl": "Λήψη επέκτασης",
      "linkSubscribe": "Εγγραφή σε πλάνο τώρα",
      "linkDashboard": "Πηγαίνετε στον πίνακα ελέγχου",
      "exclusion": {
        "title": "Ονόματα εταιρειών και προϊόντων",
        "description": ""
      },
      "finishButton": "Ολοκλήρωση ρύθμισης",
      "subdomains": "Υποτομείς",
      "subdomain_setup": "Ρύθμιση domain",
      "subdomain_auto_setup": "Σύνδεση DNS αυτόματα",
      "subdomain_manual_setup": "Προσθήκη εγγραφών DNS μόνοι μου",
      "subdomain_skip": "Να γίνει αργότερα",
      "auto_subdomains_info": "Ο δημιουργός ιστοτόπου σας απαιτεί διαμόρφωση DNS για να ορίσει γλώσσες ανά υποτομέα (π.χ. el.domain.com).",
      "auto_subdomains_info_2": "Μπορείτε να το κάνετε αυτό αυτόματα με το Entri. Απλά πατήστε το κουμπί «Σύνδεση DNS αυτόματα» για να ξεκινήσετε τη σύνδεση με τον διαχειριστή DNS σας και να τα προσθέσετε με το Entri.",
      "auto_subdomains_info_manual": "Ή μπορείτε να διαμορφώσετε χειροκίνητα το domain σας πατώντας το κουμπί «Προσθήκη εγγραφών DNS μόνοι μου».",
      "breadcrumbs": {
        "step1": "Βήμα 1: Τομέας, CMS και Γλώσσες",
        "step2": "Βήμα 2: Γλώσσα DNS",
        "step3": "Βήμα {{step}}: Οδηγίες εγκατάστασης"
      }
    },
    "form": {
      "urls": {
        "dash": "Παύλα -",
        "underscore": "Κάτω παύλα _",
        "title": "Μετάφραση URLs",
        "description": "Θέλετε να μεταφράσετε όλες τις σελίδες",
        "char_description": "Χαρακτήρας για αντικατάσταση μη επιτρεπόμενων χαρακτήρων στα URLs",
        "advertisement_title": "⚠ Έχετε ορίσει πολλές γλώσσες.\n",
        "advertisement": "Συνιστούμε συνήθως να ξεκινάτε τη μετάφραση ιστοτόπων με λίγες γλώσσες αρχικά. Έτσι θα έχετε μια ιδέα για το πόσες λέξεις διαθέτει ο ιστότοπός σας. Είναι επίσης καλύτερα για SEO, καθώς τα bots της Google θα ευρετηριάσουν πιο γρήγορα όλες σας τις σελίδες αν έχετε λιγότερες σελίδες στην αρχή. Μετά από μια εβδομάδα μπορείτε να προσθέσετε περισσότερες γλώσσες και ούτω καθεξής."
      },
      "url": {
        "title": "Url",
        "description": "Βάλτε το URL του κύριου domain σας ξεκινώντας με http:// ή https://",
        "placeholder": "URL domain",
        "advertisement_http": {
          "title": "Δεν χρησιμοποιείτε το πρωτόκολλο https",
          "description": "Παρακαλούμε ελέγξτε ότι το domain σας όντως δεν χρησιμοποιεί το πρωτόκολλο https, το οποίο θεωρείται πλέον συνιστώμενο."
        },
        "advertisement_www": {
          "title": "Ο υποτομέας σας δεν είναι www",
          "description": "Τις περισσότερες φορές ο προεπιλεγμένος υποτομέας είναι www (όπως https://www.mydomain.com). Μπορεί να μην ισχύει αυτό για εσάς, παρακαλούμε ωστόσο επιβεβαιώστε ξανά ότι το domain που θέλετε να προσθέσετε είναι το σωστό."
        },
        "invalid_url": {
          "line1": "Δεν μπορέσαμε να εντοπίσουμε το domain σας. Παρακαλούμε ελέγξτε ότι το domain σας είναι δημόσια προσβάσιμο μέσω Διαδικτύου και δεν ανακατευθύνεται σε άλλη τοποθεσία.",
          "line2": "Αν είστε σίγουροι ότι το domain σας είναι προσβάσιμο, μπορείτε να παραλείψετε την επαλήθευση του domain και να πατήσετε ξανά το κουμπί \"Επόμενο βήμα\".",
          "contact": "Σε κάθε περίπτωση μπορείτε να επικοινωνήσετε μαζί μας στο",
          "force": "Παράλειψη επαλήθευσης domain"
        },
        "invalid_subdomain_url": "Αυτή η διεύθυνση URL δεν επιτρέπεται. Τα υποτομείς πρέπει να έχουν τη μορφή: https://www.domain.tld ή https://domain.tld χωρίς υποκατάλογο."
      },
      "account": {
        "title": "Λογαριασμός",
        "description": "Επιλέξτε λογαριασμό για να αναθέσετε αυτό το domain",
        "placeholder": "Επιλέξτε λογαριασμό...",
        "feedback": "Πρέπει να επιλέξετε λογαριασμό"
      },
      "platform": {
        "title": "Πλατφόρμα",
        "description": "Παρακαλούμε επιλέξτε την πλατφόρμα του ιστοτόπου σας ανάλογα με το όνομα του CMS.",
        "learn": "Μάθετε πώς να το επιλέξετε",
        "placeholder": "Αναζήτηση πλατφόρμας ανά CMS...",
        "info": {
          "title": "⚠ Η πλατφόρμα αυτή έχει προστεθεί πρόσφατα.\n",
          "desc": "Αυτή η πλατφόρμα δημιουργού ιστοτόπων υποστηρίζεται από το Linguise, αν και έχει προστεθεί πρόσφατα. Αν αντιμετωπίσετε οποιοδήποτε ζήτημα, παρακαλούμε επικοινωνήστε μαζί μας μέσω email άμεσης υποστήριξης:"
        },
        "description_read_only": "Η πλατφόρμα που χρησιμοποιεί ο ιστότοπός σας",
        "feedback": "Πρέπει να επιλέξετε πλατφόρμα"
      },
      "language": {
        "title": "Γλώσσα",
        "description": "Επιλέξτε τη βασική γλώσσα του ιστοτόπου σας",
        "placeholder": "Επιλέξτε γλώσσα...",
        "feedback": "Πρέπει να επιλέξετε γλώσσα",
        "description_read_only": "Βασική γλώσσα του ιστοτόπου σας"
      },
      "token": {
        "title": "Κλειδί API",
        "description": "Αυτό είναι το κλειδί API για αντιγραφή στον ιστότοπό σας",
        "copy": "Αντιγραφή στο πρόχειρο",
        "reset": "Επαναφορά κλειδιού API",
        "reset_confirm": "Παρακαλούμε επιβεβαιώστε την επαναφορά του κλειδιού API"
      },
      "languages": {
        "title": "Γλώσσες μετάφρασης",
        "description": "Επιλέξτε τις γλώσσες στις οποίες θέλετε να μεταφράζεται ο ιστότοπός σας",
        "placeholder": "Επιλέξτε γλώσσες...",
        "feedback": "Πρέπει να επιλέξετε γλώσσα"
      },
      "defaultRules": {
        "title": "Προεπιλεγμένοι κανόνες",
        "description": "Έχουμε ορίσει ένα σύνολο απαραίτητων κανόνων για βελτίωση της μετάφρασης και αποφυγή ανεπιθύμητου περιεχομένου, όπως το πίνακας ελέγχου του WordPress.\nΜπορείτε να αφαιρέσετε ή να επεξεργαστείτε αυτούς τους κανόνες αργότερα αν θέλετε."
      },
      "disallow_deletion": "Δεν μπορείτε να διαγράψετε domain με ενεργή συνδρομή",
      "delete_confirm": "Παρακαλούμε επιβεβαιώστε τη διαγραφή του domain",
      "delete": "Διαγραφή domain",
      "dynamic": {
        "title": "Μετάφραση Δυναμικού Περιεχομένου",
        "description": "Δυναμικό περιεχόμενο που δημιουργείται από JavaScript και αιτήματα AJAX θα μεταφράζεται (αυτή η επιλογή θα αυξήσει τη χρήση μεταφράσεών σας)"
      },
      "partial_translations": {
        "title": "Επίτρεψη μερικής μετάφρασης",
        "description": "Αν ο λογαριασμός σας έχει φτάσει το όριο μετάφρασης αλλά η σελίδα εξακολουθεί να χρειάζεται μετάφραση, το Linguise μπορεί να συνεχίσει να εμφανίζει τη σελίδα με το ήδη μεταφρασμένο περιεχόμενο.\nΩστόσο, κάποια τμήματα της σελίδας θα παραμείνουν αμετάφραστα μέχρι να αναβαθμίσετε την ποσόστωσή σας.\n\nΈνα μικρό ποσοστό αμετάφραστου περιεχομένου συνήθως δεν βλάπτει το SEO, όμως πολύ αμετάφραστο περιεχόμενο μπορεί να επηρεάσει αρνητικά την εμπειρία χρήστη.\nΓια να το αντιμετωπίσετε αυτό, μπορείτε να ορίσετε ένα όριο ποσοστού αμετάφραστου περιεχομένου ανά σελίδα. Αν το αμετάφραστο περιεχόμενο υπερβεί αυτό το όριο, οι χρήστες θα ανακατευθύνονται αυτόματα στην έκδοση της σελίδας στην αρχική γλώσσα.",
        "never": "Ποτέ"
      },
      "translate_error_pages": {
        "title": "Μετάφραση σελίδων σφάλματος",
        "description": "Το Linguise μπορεί να μεταφράσει όλες τις σελίδες σφάλματος, ωστόσο αν η σελίδα σφάλματος περιέχει δυναμικό περιεχόμενο, όπως IP διεύθυνση ή ID αιτήματος, θα πρέπει να αποφύγετε τη μετάφρασή τους.",
        "not_found_page": {
          "title": "Μετάφραση σελίδας 404"
        },
        "error_page": {
          "title": "Μετάφραση άλλων σελίδων σφάλματος"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Βρέθηκε υπάρχον domain",
          "description": "Βρέθηκε υπάρχον domain για αυτόν τον χρήστη, θέλετε να το χρησιμοποιήσετε;"
        }
      },
      "search_tl": {
        "title": "Αναζήτηση Μεταφράσεων",
        "description": "Ενεργοποιήστε την αναζήτηση μεταφράσεων για την πλατφόρμα του ιστοτόπου σας (Πειραματικό, αυτή η επιλογή θα αυξήσει τη χρήση μεταφράσεών σας)"
      },
      "shopify_promo": {
        "info": "Καλά νέα! Πλέον διαθέτουμε μια εγγενή εφαρμογή Shopify που μπορείτε να εγκαταστήσετε από το Shopify App Store.",
        "hyperlink": "Κάντε κλικ εδώ και κάντε την εγκατάσταση του Linguise από την εφαρμογή.",
        "next_btn": "Μεταβείτε στο κατάστημα Shopify για να εγκαταστήσετε την εφαρμογή",
        "info_legacy": "Καλά νέα! Πλέον διαθέτουμε μια εγγενή εφαρμογή Shopify που μπορείτε να εγκαταστήσετε από το Shopify App Store.",
        "description_legacy": "Επιλέξτε την πλατφόρμα \"Shopify\" αντί για το \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Καλά νέα! Πλέον διαθέτουμε μια εγγενή εφαρμογή Wix που μπορείτε να εγκαταστήσετε από το Wix App Market.",
        "hyperlink": "Κάντε κλικ εδώ και κάντε την εγκατάσταση του Linguise από την εφαρμογή.",
        "next_btn": "Μεταβείτε στο Wix App Market για να εγκαταστήσετε την εφαρμογή",
        "info_legacy": "Καλά νέα! Πλέον διαθέτουμε μια εγγενή εφαρμογή Wix που μπορείτε να εγκαταστήσετε από το Wix App Market.",
        "description_legacy": "Επιλέξτε την πλατφόρμα \"Wix\" αντί για το \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Δεν μπορείτε να διαγράψετε αυτόν τον τομέα όσο είναι ακόμη διαθέσιμο ένα όριο τεχνητής νοημοσύνης.\n\nΕπικοινωνήστε με την ομάδα υποστήριξής μας εάν θέλετε να διαγράψετε αυτόν τον τομέα στη διεύθυνση",
      "language_removal": {
        "card": {
          "title": "Διαγραφή μεταφράσεων αφαιρεμένων γλωσσών",
          "description": "Αυτές οι γλώσσες αφαιρέθηκαν από τον ιστότοπό σας, αλλά οι αποθηκευμένες μεταφράσεις τους εξακολουθούν να υπολογίζονται στο όριό σας. Διαγράψτε τις για να ανακτήσετε τις λέξεις.",
          "button": "Διαγραφή μεταφράσεων"
        },
        "hint": "Οι λέξεις που χρησιμοποιήθηκαν θα επιστραφούν στο όριό σας. Μπορείτε να το κάνετε μία φορά κάθε {{days}} ημέρες για κάθε ιστότοπο.",
        "modal": {
          "title": "Διαγραφή μεταφράσεων;",
          "intro": "Αυτές οι μεταφράσεις θα διαγραφούν οριστικά:",
          "warning": "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. Οι λέξεις που χρησιμοποιήθηκαν θα επιστραφούν στο όριό σας, κάτι που μπορεί να χρειαστεί λίγα λεπτά.",
          "limit": "Μπορείτε να το κάνετε μία φορά κάθε {{days}} ημέρες για κάθε ιστότοπο.",
          "confirm": "Διαγραφή μεταφράσεων"
        },
        "scheduled": "Οι μεταφράσεις διαγράφονται και το όριό σας θα ενημερωθεί σύντομα.",
        "cooldown": "Οι μεταφράσεις αυτού του ιστότοπου διαγράφηκαν πρόσφατα. Μπορείτε να τις διαγράψετε ξανά στις {{date}}.",
        "latest_completed": {
          "title": "Τελευταία ολοκληρωμένη διαγραφή",
          "description": "Δείτε τις γλώσσες που διαγράφηκαν και τις λέξεις που επιστράφηκαν στο όριό σας.",
          "languages": "Γλώσσες που διαγράφηκαν",
          "words_returned": "Λέξεις που επιστράφηκαν στο όριό σας: {{words}}",
          "completed_at": "Ολοκληρώθηκε στις {{date}}"
        },
        "status": {
          "recent_title": "Πρόσφατη διαγραφή μεταφράσεων",
          "recent_description": "Παρακολουθήστε την τελευταία διαγραφή και δείτε πότε θα είναι διαθέσιμη η επόμενη.",
          "progress_title": "Πρόοδος διαγραφής",
          "loading": "Έλεγχος προόδου διαγραφής...",
          "unavailable": "Δεν ήταν δυνατή η φόρτωση της προόδου διαγραφής. Ανανεώστε τη σελίδα και δοκιμάστε ξανά.",
          "label": "Κατάσταση",
          "pending": "Σε αναμονή",
          "processing": "Σε εξέλιξη",
          "completed": "Ολοκληρώθηκε",
          "failed": "Απέτυχε",
          "unknown": "Η κατάσταση δεν είναι διαθέσιμη",
          "percent": "{{percent}}% ολοκληρώθηκε",
          "current_stage": "Τρέχον βήμα: {{stage}}",
          "processed": "Έγινε επεξεργασία {{processed}} εγγραφών",
          "processed_total": "Έγινε επεξεργασία {{processed}} από {{total}} εγγραφές",
          "requested_at": "Ζητήθηκε στις {{date}}",
          "started_at": "Ξεκίνησε στις {{date}}",
          "completed_at": "Ολοκληρώθηκε στις {{date}}",
          "cooldown_period": "Μπορείτε να το κάνετε μία φορά κάθε {{days}} ημέρες για κάθε ιστότοπο.",
          "cooldown_blocked": "Δεν είναι δυνατή η έναρξη άλλης διαγραφής ακόμη.",
          "stage": {
            "queued": "Αναμονή για έναρξη",
            "processing": "Σε εξέλιξη",
            "refund_summary": "Υπολογισμός επιστρεφόμενων λέξεων",
            "search_translations": "Διαγραφή μεταφράσεων αναζήτησης",
            "url_translations": "Διαγραφή μεταφράσεων URL",
            "translations": "Διαγραφή μεταφράσεων",
            "completed": "Ολοκληρώθηκε",
            "failed": "Απέτυχε",
            "unknown": "Σε εξέλιξη"
          }
        },
        "forbidden": "Δεν έχετε άδεια διαγραφής μεταφράσεων."
      }
    },
    "main": {
      "edit": "Επεξεργασία domain",
      "add": "Προσθήκη domain",
      "wizard": "Καλώς ήλθατε! Οδηγός δημιουργίας νέου domain",
      "common": "Τομέας"
    },
    "notice": {
      "broken_card": "Δεν μπορέσαμε να ανανεώσουμε το πλάνο σας για {{url}} με την τρέχουσα μέθοδο πληρωμής· παρακαλούμε ενημερώστε την κάρτα πληρωμής σας",
      "quota_reached": "Έχετε φτάσει την ποσόστωση μετάφρασης για {{url}}· αναβαθμίστε για να συνεχίσει η μετάφραση του ιστοτόπου σας",
      "ai_no_subscription": "Η AI μετάφραση για {{url}} απαιτεί ενεργή συνδρομή ή ενεργή δοκιμή. Θα σταματήσει χωρίς αυτήν· αναβαθμίστε για να συνεχίσετε",
      "important": "Σημαντικό",
      "quota_reached_button": "Αναβαθμίστε το πλάνο σας τώρα",
      "broken_card_button": "Ενημερώστε την κάρτα πληρωμής σας",
      "ai_no_subscription_button": "Αναβαθμίστε το πλάνο σας τώρα",
      "quota_warning": "Το όριο μετάφρασης για το {{url}} έχει φτάσει το {{throttling_used_percent}}%, αυτό θα επαναφερθεί σε {{ttl}}",
      "locked": "Ο τομέας {{url}} είναι προς το παρόν κλειδωμένος για μετεγκατάσταση, μπορείτε ακόμα να έχετε πρόσβαση στον ιστότοπό σας, αλλά δεν μπορείτε να επεξεργαστείτε ή να προσθέσετε νέες μεταφράσεις!"
    },
    "subdomains": {
      "config_ok": "Το DNS των υποτομέων έχει ρυθμιστεί σωστά.",
      "config_invalid": "Το DNS των υποτομέων απαιτεί επιπλέον ρυθμίσεις για να λειτουργήσει.",
      "config_check": "Γίνεται έλεγχος της διαμόρφωσης DNS των υποτομέων, παρακαλώ περιμένετε...",
      "entri_timeout": "Η Entri ανέφερε ότι η διάδοση DNS των υποτομέων σας έληξε· θα χρειαστεί να προσπαθήσετε ξανά ή να το κάνετε χειροκίνητα.",
      "entri_process": "Το DNS σας έχει προστεθεί μέσω Entri και συνήθως χρειάζεται 10-30 λεπτά για να διαδοθεί (εφαρμογή όλων των γλωσσικών υποτομέων όπως el.domain.com). Αν η επικύρωση DNS δεν ολοκληρωθεί εντός 24 ωρών, επικοινωνήστε με την ομάδα υποστήριξής μας: support@linguise.com",
      "entri_ok": "Η διάδοση DNS βρίσκεται σε εξέλιξη! Αναμονή για ολοκλήρωση...",
      "infos": "Πρέπει να προσθέσετε αυτές τις καταχωρήσεις DNS στις εγγραφές τομέα DNS σας για να ενεργοποιήσετε τη μετάφραση. Κάντε κλικ στο κουμπί ελέγχου όταν ολοκληρωθεί. Είναι πιθανό η μετάδοση των εγγραφών DNS να διαρκέσει λίγο, επομένως ίσως χρειαστεί να επιστρέψετε μετά από λίγα λεπτά ή ώρες.",
      "check": "Έλεγχος διαμόρφωσης DNS"
    },
    "subscription": {
      "next_payment_amount": "Επερχόμενες χρεώσεις",
      "next_payment_date": "Ημερομηνία επόμενης πληρωμής",
      "invoice": {
        "header": "Ιστορικό τιμολογίων",
        "date": "Ημερομηνία",
        "amount_due": "Ποσό",
        "status": "Κατάσταση",
        "actions": "Ενέργειες",
        "description": "Μόλις είναι διαθέσιμες οι συναλλαγές, μπορείτε να τις δείτε εδώ.",
        "status_text": {
          "draft": "Πρόχειρο",
          "failed": "Απέτυχε",
          "open": "Εκκρεμεί",
          "paid": "Πληρωμένο",
          "retrying": "Γίνεται επανάληψη",
          "uncollectible": "Ανεπίδεκτο είσπραξης",
          "void": "Άκυρο"
        },
        "view": "Προβολή",
        "empty": "Δεν βρέθηκαν πρόσφατα τιμολόγια για αυτή τη συνδρομή",
        "retry_payment": "Επανάληψη"
      },
      "next_cancellation": "Ημερομηνία ακύρωσης",
      "cancel": "Ακύρωση συνδρομής",
      "change_plan": "Αλλαγή πλάνου",
      "change": "Αλλαγή",
      "suspend": "Αναστολή πληρωμής",
      "resume": "Συνέχιση συνδρομής",
      "back": "Πίσω",
      "save": "Αποθήκευση",
      "confirm_resume": "Είστε βέβαιοι ότι θέλετε να συνεχίσετε αυτή τη συνδρομή;",
      "confirm_cancel": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτή τη συνδρομή;",
      "confirm_header": "Είστε βέβαιοι;",
      "missing_status": "Αυτή η συνδρομή λείπει",
      "not_found": "Δεν βρέθηκε συνδρομή για αυτόν τον τομέα",
      "confirm_manual_retry": "Είστε βέβαιοι ότι θέλετε να επαναλάβετε αυτή την πληρωμή;",
      "no_payment_method": "Άγνωστο",
      "remove_billing": "Αφαίρεση",
      "shopify_maneged": "Αυτή η συνδρομή διαχειρίζεται από το Shopify. Παρακαλούμε διαχειριστείτε τη μέσω του πίνακα διαχείρισης Shopify.",
      "unknown_plan": "Άγνωστο πρόγραμμα"
    }
  },
  "domain_listing": {
    "add": "Προσθήκη ιστότοπου",
    "select": "Επιλέξτε τομέα"
  },
  "editable": {
    "number": "αριθμός {{id}}"
  },
  "footer": {
    "about": "Σχετικά",
    "support": "Υποστήριξη"
  },
  "frontendEditor": {
    "main": "Ζωντανός Επεξεργαστής",
    "description": "Ο Ζωντανός Επεξεργαστής σάς βοηθά να επεξεργάζεστε απευθείας τις μεταφράσεις στον ιστότοπό σας.",
    "button": "Άνοιγμα Ζωντανού Επεξεργαστή",
    "language_selection": "Επιλογή γλώσσας μετάφρασης",
    "video_label": "Μάθετε πώς να χρησιμοποιείτε τον ζωντανό επεξεργαστή"
  },
  "general": {
    "403": {
      "tab_title": "Ουπς - Σφάλμα 403",
      "title": "Απαγορεύεται η πρόσβαση",
      "message": "Φαίνεται ότι δεν έχετε πρόσβαση στη ζητούμενη σελίδα.",
      "home": "Επιστροφή στην Αρχική"
    },
    "404": {
      "tab_title": "Ουπς - Σφάλμα 404",
      "title": "Η σελίδα δεν βρέθηκε",
      "message": "Φαίνεται ότι πήρατε λάθος στροφή. Μην ανησυχείτε... συμβαίνει και στους καλύτερους. Εδώ είναι ένα μικρό tip που μπορεί να σας βοηθήσει να επιστρέψετε στο σωστό δρόμο.",
      "home": "Επιστροφή στην Αρχική"
    },
    "500": {
      "tab_title": "Σφάλμα 500",
      "title": "Εσωτερικό σφάλμα διακομιστή",
      "message": "Γιατί δεν δοκιμάζετε να ανανεώσετε τη σελίδα σας; ή μπορείτε να επικοινωνήσετε μαζί μας",
      "home": "Επιστροφή στην Αρχική"
    },
    "fields": {
      "alert": "Μερικά πεδία δεν είναι έγκυρα, παρακαλώ διορθώστε τα μη έγκυρα πεδία.",
      "invalid": "Αυτό το πεδίο δεν είναι έγκυρο",
      "phone_re": "Ο αριθμός τηλεφώνου δεν είναι έγκυρος",
      "phone_invalid": "Ο αριθμός τηλεφώνου δεν είναι έγκυρος",
      "email": "Το πεδίο ηλεκτρονικού ταχυδρομείου δεν είναι έγκυρο"
    },
    "table": {
      "no_data": "Δεν υπάρχουν ακόμα δεδομένα εδώ..."
    },
    "saving": "Αποθήκευση ...",
    "save": "Αποθήκευση",
    "save_and_quit": "Αποθήκευση & Έξοδος",
    "invite": "Πρόσκληση",
    "cancel": "Ακύρωση",
    "yes": "Ναι",
    "no": "Όχι",
    "nextStep": "Επόμενο βήμα",
    "loading": "Παρακαλώ περιμένετε μέχρι να φορτώσει η εφαρμογή",
    "goback": "Επιστροφή",
    "manage": "Διαχείριση",
    "delete": "Διαγραφή",
    "deleting": "Διαγραφή ...",
    "confirm": "Επιβεβαίωση",
    "unknown": "Άγνωστο",
    "hide": "Κρύβω",
    "show": "Επίδειξη",
    "on": "Επί",
    "off": "Μακριά από",
    "default": "Προεπιλογή"
  },
  "home": {
    "header": "Αρχική",
    "manage": "Διαχείριση συνδρομής",
    "canceled": "Προγραμματισμένο για ακύρωση",
    "activate_now": "Ενεργοποίηση τώρα",
    "activate_plan_now": "Εγγραφή τώρα",
    "upgrade_plan_now": "Αναβάθμιση πλάνου τώρα",
    "trial_message_part_1": "Βρίσκεστε σε δοκιμαστικό πλάνο, ",
    "trial_message_part_2": "μπορείτε να ενεργοποιήσετε κάποιο πλάνο οποτεδήποτε.",
    "add": "Προσθήκη τομέα",
    "table": {
      "title": "Τομείς",
      "description": "Λίστα των τομέων σας· κάντε κλικ σε κάποιον τομέα για να διαχειριστείτε τις μεταφράσεις"
    },
    "domains": {
      "empty": "Δεν έχετε κανένα τομέα σε αυτόν τον λογαριασμό"
    },
    "accountsList": {
      "title": "Λογαριασμοί",
      "add": "Προσθήκη νέου λογαριασμού",
      "name": "Όνομα λογαριασμού"
    },
    "update_credit_card": "Ενημέρωση στοιχείων πιστωτικής κάρτας",
    "cancelling_subs": "Ακύρωση στις {{0}}",
    "resume_subscription": "Συνέχιση συνδρομής",
    "shopify_managed": "Διαχείριση από το Shopify",
    "trial_ends_at": "Λήγει στις {{0}}",
    "free_trial": "Δωρεάν δοκιμή",
    "no_subs": "Δεν υπάρχει ενεργή συνδρομή"
  },
  "invoices": {
    "title": "Τιμολόγια",
    "list": {
      "title": "Λίστα τιμολογίων"
    },
    "table": {
      "customer": "Πελάτης",
      "domain": "Τομέας",
      "amountPaid": "Πληρωμένο ποσό",
      "status": "Κατάσταση",
      "date": "Ημερομηνία",
      "invoice": "Τιμολόγιο",
      "pay": "Πληρωμή τιμολογίου",
      "actions": "Ενέργειες",
      "deleted_domain": "Διαγραμμένος τομέας",
      "plan_name": "Πρόγραμμα",
      "action": "Ενέργεια"
    },
    "listPending": {
      "title": "Λίστα εκκρεμών τιμολογίων"
    }
  },
  "language_settings": {
    "display": "Εμφάνιση λίστας γλωσσών",
    "position": "Θέση",
    "display_help_text": "Εμφάνιση σημαίας ή/και ονομάτων γλωσσών. Η προεπιλεγμένη θέση του διακόπτη γλώσσας μπορεί να είναι οπουδήποτε στο περιεχόμενο ή σε σταθερή θέση που παραμένει σταθερή ή κινείται κατά το κύλιση",
    "side_by_side": "Δίπλα-δίπλα",
    "dropdown": "Αναπτυσσόμενο",
    "popup": "Αναδυόμενο",
    "flag": "Σημαία",
    "lang_name": "Όνομα γλώσσας",
    "lang_short_name": "Σύντομα ονόματα",
    "positions": {
      "in_place": "Στη θέση",
      "top_left": "Πάνω αριστερά",
      "top_left_no_scroll": "Πάνω αριστερά (χωρίς κύλιση)",
      "top_right": "Πάνω δεξιά",
      "top_right_no_scroll": "Πάνω δεξιά (χωρίς κύλιση)",
      "bottom_left": "Κάτω αριστερά",
      "bottom_left_no_scroll": "Κάτω αριστερά (χωρίς κύλιση)",
      "bottom_right": "Κάτω δεξιά",
      "bottom_right_no_scroll": "Κάτω δεξιά (χωρίς κύλιση)"
    },
    "lang_names_display": {
      "title": "Εμφάνιση ονομάτων γλώσσας",
      "help_text": "Στον διακόπτη γλώσσας, εμφάνιση των ονομάτων γλώσσας στα Αγγλικά ή στη γηγενή τους γλώσσα, π.χ. French ή Français",
      "english": "Αγγλικά",
      "native_languages": "Γηγενείς γλώσσες"
    },
    "flag_shape": {
      "title": "Στυλ σημαίας",
      "help_text": "Χρήση στρογγυλών ή ορθογώνιων εικονιδίων σημαίας σε μορφή svg",
      "round": "Στρογγυλή",
      "rectangular": "Ορθογώνια"
    },
    "english_flag_type": {
      "title": "Τύπος σημαίας Αγγλικών",
      "help_text": "Χρήση της σημαίας της Μεγάλης Βρετανίας ή των ΗΠΑ για τα Αγγλικά",
      "usa": "Σημαία ΗΠΑ",
      "great_britain": "Σημαία Μεγάλης Βρετανίας"
    },
    "german_flag_type": {
      "title": "Τύπος σημαίας Γερμανικά",
      "help_text": "Χρήση της σημαίας της Αυστρίας ή της Γερμανίας για τα Γερμανικά",
      "german": "Σημαία Γερμανίας",
      "austria": "Σημαία Αυστρίας"
    },
    "spain_flag_type": {
      "title": "Τύπος σημαίας Ισπανικά",
      "help_text": "Χρήση της σημαίας του Μεξικού ή της Ισπανίας για τα Ισπανικά",
      "spanish": "Σημαία Ισπανίας",
      "mexico": "Σημαία Μεξικού",
      "peruvian": "Σημαία Περού"
    },
    "portugal_flag_type": {
      "title": "Τύπος σημαίας Πορτογαλικά",
      "help_text": "Χρήση της σημαίας της Πορτογαλίας ή της Βραζιλίας για τα Πορτογαλικά",
      "portugal": "Σημαία Πορτογαλίας",
      "brazil": "Σημαία Βραζιλίας"
    },
    "taiwanese_flag_type": {
      "title": "Τύπος σημαίας Ταϊβανέζικα",
      "help_text": "Χρήση της σημαίας της Ταϊβάν ή της Κίνας για τα Ταϊβανέζικα",
      "taiwanese": "Σημαία Ταϊβάν",
      "chinese": "Σημαία Κίνας"
    },
    "flag_border_radius": {
      "title": "Ακτίνα περιθωρίου σημαίας (px)",
      "help_text": "Εάν χρησιμοποιείτε ορθογώνια σχήματα σημαιών, μπορείτε να εφαρμόσετε προσαρμοσμένη ακτίνα περιθωρίου σε εικονοστοιχεία"
    },
    "flag_width": {
      "title": "Μέγεθος σημαίας (px)",
      "help_text": "Επιλογή μεγέθους σημαιών σε εικονοστοιχεία. Αυτό δεν αλλάζει το βάρος της εικόνας καθώς είναι σε μορφή .svg"
    },
    "lang_color": {
      "color_title": "Χρώμα ονόματος γλώσσας",
      "color_help_text": "Επιλέξτε προεπιλεγμένο χρώμα κειμένου για τα ονόματα γλωσσών σας",
      "hover_color_title": "Χρώμα αιώρησης ονόματος γλώσσας",
      "hover_color_help_text": "Επιλέξτε χρώμα κειμένου κατά το πέρασμα του ποντικιού για τα ονόματα γλωσσών σας",
      "color_popup_title": "Χρώμα γλώσσας αναδυόμενου",
      "color_popup_help_text": "Χρώμα του τίτλου γλώσσας στις περιοχές αναπτυσσόμενων ή αναδυόμενων",
      "hover_color_popup_title": "Χρώμα αιώρησης γλώσσας αναδυόμενου",
      "hover_color_popup_help_text": "Επιλέξτε χρώμα κειμένου κατά το πέρασμα του ποντικιού του τίτλου γλώσσας στις περιοχές αναπτυσσόμενων ή αναδυόμενων"
    },
    "flag_box_shadow": {
      "shadow_title": "Σκίαση περιβλήματος σημαίας",
      "shadow_help_text": "Χρώμα και μέγεθος σκίασης για τις σημαίες γλώσσας σας",
      "hover_shadow_title": "Σκίαση περιβλήματος σημαίας κατά το πέρασμα",
      "hover_shadow_help_text": "Χρώμα και μέγεθος σκίασης για τις σημαίες γλώσσας σας κατά το πέρασμα του ποντικιού",
      "shadow_h_offset": "Οριζόντια μετατόπιση σκίασης (px)",
      "shadow_v_offset": "Κάθετη μετατόπιση σκίασης (px)",
      "shadow_blur": "Θάμπωμα σκίασης (px)",
      "shadow_spread": "Εξάπλωση σκίασης (px)",
      "shadow_color": "Χρώμα σκίασης"
    },
    "order": "Σειρά γλωσσών",
    "language_order_help": "Η σειρά των γλωσσών που θα εμφανίζεται στον διακόπτη γλώσσας. Μπορείτε να σύρετε και να αφήσετε τις γλώσσες για να τις αναδιατάξετε.",
    "order_reset": "Επαναφορά σειράς",
    "language_order_dragdrop": "Μπορείτε να σύρετε και να αφήσετε τις γλώσσες για να τις αναδιατάξετε.",
    "popup_lang_name": "Όνομα γλώσσας αναδυόμενου",
    "preview": "Προεπισκόπηση γλώσσας"
  },
  "link": {
    "form": {
      "original": {
        "title": "Αρχική Πηγή",
        "description": "Προσθέστε το αρχικό URL συνδέσμου σας και αντικαταστήστε το παρακάτω ανά γλώσσα για να το μεταφράσετε",
        "srcset_description": "Επεξεργάζεστε URL εικόνας. Βεβαιωθείτε ότι διαβάζετε την τεκμηρίωση, ειδικά εάν χρησιμοποιείτε το srcset ή δεν γνωρίζετε τι είναι",
        "link": "Σύνδεσμος",
        "match_link": "Λειτουργία αντιστοίχισης",
        "match_exact": "Ακριβής",
        "match_wildcard": "Χαρακτήρας υποκατάστασης",
        "match_regex": "Κανονική έκφραση"
      },
      "alternative_languages": {
        "title": "Σύνδεσμοι προς αντικατάσταση",
        "description": "Αντικαταστήστε συνδέσμους πολυμέσων και εξωτερικούς συνδέσμους σε όλες σας τις σελίδες, ανά γλώσσα…",
        "link": "Σύνδεσμος προς αντικατάσταση"
      },
      "error": {
        "atLeastOne": "Προσθέστε τουλάχιστον μία μετάφραση.",
        "url": "Το url δεν είναι έγκυρο",
        "extension": "Ο σύνδεσμος πρέπει να έχει επέκταση, αλλά όχι .html ή .php. Επίσης, δεν πρέπει να περιέχει γλωσσικό μονοπάτι π.χ. «/fr»",
        "regex": "Το regex δεν είναι έγκυρο",
        "wildcard": "Ο σύνδεσμος με χαρακτήρα υποκατάστασης έχει μη έγκυρο πρωτόκολλο"
      }
    },
    "main": {
      "parent": "Σύνδεσμοι",
      "edit": "Επεξεργασία συνδέσμου"
    }
  },
  "links": {
    "title": "Διαχείριση συνδέσμων πολυμέσων και εξωτερικών συνδέσμων",
    "description": "Λίστα και επεξεργασία συνδέσμων πολυμέσων ή εξωτερικών συνδέσμων του ιστότοπού σας.",
    "add": "Προσθήκη συνδέσμου",
    "delete": "Διαγραφή συνδέσμου",
    "table": {
      "original": "Αρχικό",
      "language": "Γλώσσα",
      "translation": "Μετάφραση",
      "action": "Ενέργεια",
      "delete_confirm": "Επιβεβαιώστε τη διαγραφή του συνδέσμου"
    }
  },
  "members": {
    "header": "Μέλη",
    "invite": "Προσκαλέστε νέο μέλος",
    "modal": {
      "inviteHeader": "Προσκαλέστε νέο μέλος",
      "editHeader": "Επεξεργασία μέλους",
      "detachHeader": "Αποσύνδεση μέλους",
      "detachBody": "Είστε βέβαιοι ότι θέλετε να αποσυνδέσετε το μέλος από αυτόν τον λογαριασμό;",
      "selfDetachBody": "Είστε βέβαιοι ότι θέλετε να αποσυνδεθείτε από τη διαχείριση αυτού του λογαριασμού; Μετά από αυτό, δεν θα μπορείτε να έχετε πρόσβαση σε κανένα δεδομένο σχετικό με αυτόν τον λογαριασμό."
    },
    "table": {
      "title": "Λίστα μελών",
      "description": "Ρόλοι μελών και πρόσβαση σε τομείς",
      "name": "Όνομα",
      "email": "Email",
      "websites": "Ιστότοποι",
      "languages": "Γλώσσες",
      "role": "Ρόλος",
      "status": "Κατάσταση",
      "resendInvite": "επαναποστολή",
      "inviteSent": "η πρόσκληση εστάλη",
      "actions": "Ενέργειες",
      "edit": "Επεξεργασία",
      "detach": "Αποσύνδεση",
      "empty": "Δεν έχετε ακόμα κανένα μέλος",
      "all_website": "Όλοι οι ιστότοποι και οι γλώσσες",
      "roles": {
        "admin": "Διαχειριστής",
        "manager": "Διευθυντής",
        "translator": "Μεταφραστής"
      },
      "statuses": {
        "pending": "Σε εκκρεμότητα",
        "accepted": "Αποδεκτό",
        "declined": "Απορρίφθηκε"
      }
    },
    "errors": {
      "role": "Πρέπει να επιλέξετε ρόλο",
      "domains": "Πρέπει να επιλέξετε τουλάχιστον 1 ιστότοπο για τον επιλεγμένο ρόλο",
      "languages": "Πρέπει να επιλέξετε τουλάχιστον 1 γλώσσα για τους επιλεγμένους ιστότοπους"
    },
    "inviteSent": "Η πρόσκλησή σας εστάλη με επιτυχία"
  },
  "pagination": {
    "showing": "Εμφάνιση {{limit}} από {{total}} αποτελέσματα",
    "showing_only_count": "Εμφάνιση {{limit}} αποτελεσμάτων"
  },
  "payments_method": {
    "header": "Τρόποι Πληρωμής",
    "table": {
      "title": "Λίστα τρόπων πληρωμής",
      "description": "Συνδεδεμένοι τρόποι πληρωμής στον λογαριασμό σας",
      "default": "Προεπιλογή",
      "action_edit_remove": "Επεξεργασία ή κατάργηση",
      "action_remove": "Κατάργηση",
      "action_default": "Ορισμός ως προεπιλογή",
      "action_fallback": "Ορισμός ως εφεδρικός",
      "expires": "Λήγει",
      "add_new_card": "Προσθήκη τρόπου πληρωμής",
      "action_fallback_remove": "Αφαίρεση από εφεδρικούς",
      "fallback": "Εφεδρικός",
      "action_edit": "Επεξεργασία",
      "action_delete": "Διαγραφή",
      "action_default_remove": "Αφαίρεση ως προεπιλογή",
      "domain_count@@one": "Χρησιμοποιείται από {{count}} τομείς",
      "domain_count@@other": "Χρησιμοποιείται από {{count}} τομείς"
    },
    "paypal_bind": {
      "button": "Σύνδεση λογαριασμού PayPal",
      "button_load": "Γίνεται σύνδεση…",
      "disconnected": "Δεν έχει συνδεθεί",
      "success": "Ο λογαριασμός PayPal σας συνδέθηκε· θα αφαιρεθούν 5 $ από τον επόμενο λογαριασμό σας!",
      "success_no_promo": "Ο λογαριασμός PayPal σας συνδέθηκε",
      "error": "Προέκυψε σφάλμα",
      "success_header": "Επιτυχία"
    },
    "card_add": {
      "header": "Προσθήκη νέας κάρτας",
      "success": "Η νέα κάρτα συνδέθηκε με το Linguise!",
      "terms": "Παρέχοντας τα στοιχεία της κάρτας σας, επιτρέπετε στο Linguise να χρεώνει την κάρτα σας για μελλοντικές πληρωμές σύμφωνα με τους όρους υπηρεσίας μας."
    },
    "card_detail": {
      "header": "Στοιχεία κάρτας",
      "delete": {
        "error": "Δεν μπορείτε να διαγράψετε αυτόν τον τρόπο πληρωμής γιατί έχει ενεργές συνδρομές!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Συνδρομές σε αυτόν τον τρόπο πληρωμής",
        "header_domain": "Τομέας",
        "header_plan": "Πρόγραμμα",
        "header_status": "Κατάσταση",
        "header_actions": "Ενέργειες",
        "cancelling": "Ακύρωση στις: {{0}}",
        "next_payment": "Επόμενη πληρωμή στις: {{0}}",
        "action_renew": "Ανανέωση",
        "no_subs_header": "Δεν υπάρχουν συνδρομές προς εμφάνιση",
        "no_subs_desc": "Μόλις δημιουργηθεί συνδρομή σε αυτή την κάρτα, όλες οι πληροφορίες θα εμφανιστούν εδώ",
        "action_manage": "Διαχείριση"
      },
      "status": {
        "active": "Ενεργή",
        "canceled": "Ακυρώθηκε",
        "incomplete": "Απλήρωτη",
        "incomplete_expired": "Απλήρωτη (Έληξε)",
        "missing": "Σφάλμα",
        "past_due": "Εκπρόθεσμη",
        "trialing": "Δοκιμαστική",
        "unpaid": "Απλήρωτη"
      }
    },
    "delete_confirm_body": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον τρόπο πληρωμής; Η ενέργεια δεν μπορεί να αντιστραφεί!",
    "delete_confirm_header": "Διαγραφή τρόπου πληρωμής;",
    "card_edit": {
      "header": "Επεξεργασία κάρτας",
      "billing_header": "Στοιχεία χρέωσης",
      "address_error": "Απαιτείται διεύθυνση!",
      "card_number": "Αριθμός κάρτας",
      "card_expiry": "Ημερομηνία λήξης",
      "expiry_error_month": "Μη έγκυρος μήνας",
      "expiry_error_year": "Μη έγκυρο έτος",
      "expiry_error_expired": "Η ημερομηνία λήξης της κάρτας σας είναι παρελθούσα.",
      "card_header": "Στοιχεία κάρτας",
      "expiry_error_empty": "Το πεδίο είναι υποχρεωτικό!"
    }
  },
  "plans": {
    "per": "ανά",
    "wordsTranslated": "λέξεις μεταφρασμένες",
    "current": "Τρέχον",
    "archived": "Αρχειοθετημένο",
    "day": "ημέρα",
    "week": "εβδομάδα",
    "month": "μήνας",
    "year": "έτος",
    "activate": "Ενεργοποίηση",
    "cancel": "Ακύρωση",
    "change": "Αλλαγή",
    "upgrade": "Αναβάθμιση",
    "downgrade": "Υποβάθμιση",
    "resume": "Συνέχεια",
    "notEnoughWords": "Μη επαρκείς λέξεις",
    "yearIntervalOnly": "Δεν είναι δυνατή η μετάβαση από ετήσιο πλάνο",
    "subsCanceled": "Υπάρχει ήδη μια ακύρωση συνδρομής σε εξέλιξη",
    "wordsUnlimited": "Απεριόριστες λέξεις",
    "tabs": {
      "day": "Ημερήσιες τιμές",
      "week": "Εβδομαδιαίες τιμές",
      "month": "Μηνιαίες τιμές",
      "year": "Ετήσιες τιμές",
      "sub_texts": {
        "day": "Μια σταθερή τιμή, κάθε μέρα",
        "week": "Μια σταθερή τιμή, κάθε εβδομάδα",
        "month": "Μια σταθερή τιμή, κάθε μήνα",
        "year": "Ένας μήνας δωρεάν, ένας λογαριασμός ανά έτος"
      }
    },
    "details": {
      "new_languages": "Προσθέστε νέες γλώσσες οποιαδήποτε στιγμή",
      "one_month_trial": "Δωρεάν δοκιμή ενός μήνα για κάθε νέο website",
      "multi_content_indexed": "Το 100% του πολύγλωσσου περιεχομένου ευρετηριάζεται",
      "translate_new_content": "Μεταφράστε νέο περιεχόμενο άμεσα",
      "free_installation": "Δωρεάν εγκατάσταση και ρύθμιση",
      "compared_monthly_plan": "Ένας μήνας δωρεάν σε σχέση με τους μηνιαίους πλάνο",
      "risk_free_recurring": "Ασφαλής επαναλαμβανόμενη αποτυχία πληρωμής",
      "unlimited_languages": "Απεριόριστες γλώσσες & προβολές σελίδων",
      "high_server_resources": "Υψηλοί πόροι διακομιστή",
      "billed": {
        "day": "Χρεώνεται ημερησίως",
        "week": "Χρεώνεται εβδομαδιαίως",
        "month": "Χρεώνεται μηνιαίως",
        "year": "Χρεώνεται ετήσια"
      },
      "request_max_size": "{{0}} μέγιστο μέγεθος αιτήματος"
    },
    "frequent_question": {
      "title": "Συχνές ερωτήσεις",
      "questions": {
        "trial": {
          "question": "Μπορώ να χρησιμοποιήσω τη δοκιμή σε νέο domain ιστοσελίδας;",
          "answer": "Ναι, προσφέρουμε 30 ημέρες δωρεάν δοκιμή για κάθε νέο domain ιστοσελίδας που προσθέτετε στον λογαριασμό σας. Έτσι μπορείτε να δοκιμάσετε πλήρως την υπηρεσία μετάφρασης στο νέο σας site."
        },
        "seo": {
          "question": "Πόσος χρόνος χρειάζεται για να βελτιωθεί το SEO μου;",
          "answer": "Το περιεχόμενο, και το πολύγλωσσο περιεχόμενο, χρειάζεται χρόνο να ευρετηριαστεί πλήρως και να καταταγεί καλά. Ανάλογα με την επισκεψιμότητα και το μέγεθος του site, κυμαίνεται μεταξύ 3 και 6 εβδομάδων."
        },
        "quota": {
          "question": "Περιλαμβάνονται οι ανθρώπινες μεταφράσεις στο όριο των λέξεων;",
          "answer": "Όχι, το όριο λέξεων αφορά μόνο τις αυτόματες μηχανικές μεταφράσεις. Οι μεταφραστές μπορούν να επεξεργάζονται χειροκίνητα τις αυτόματες μεταφράσεις χωρίς περιορισμό."
        }
      }
    },
    "best_offer": "Καλύτερη προσφορά",
    "period": {
      "days@@one": "ημέρα",
      "days@@other": "{{count}} ημέρες",
      "hours@@one": "ώρα",
      "hours@@other": "{{count}} ώρες",
      "minutes@@one": "λεπτό",
      "minutes@@other": "{{count}} λεπτά",
      "seconds@@one": "δευτερόλεπτο",
      "seconds@@other": "{{count}} δευτερόλεπτα"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} λέξεις ανά {{period}}"
  },
  "profile": {
    "welcome": "Καλώς ήρθες!",
    "account": "Ο Λογαριασμός μου",
    "subscriptions": "Συνδρομές",
    "logout": "Αποσύνδεση"
  },
  "register": {
    "errors": {
      "password": "Ελάχιστοι 8 χαρακτήρες, οποιοδήποτε σύμβολο"
    }
  },
  "route": {
    "dashboard": "Ταμπλό",
    "rules": "Κανόνες",
    "translations": "Μεταφράσεις",
    "search_translations": "Αναζητήσεις",
    "urls_translations": "Μεταφράσεις URLs",
    "links": "Μέσα και εξωτερικοί σύνδεσμοι",
    "online_editor": "Ζωντανός Επεξεργαστής",
    "settings": "Ρυθμίσεις",
    "domain": {
      "finish": "Ρυθμίσεις",
      "preconfig": "Ρυθμίσεις"
    },
    "home": "Αρχική",
    "domain_list": "Λίστα domain",
    "members": "Μέλη",
    "invoices": "Τιμολόγια",
    "billing": "Στοιχεία χρέωσης",
    "language_display": "Εμφάνιση σημαιών γλώσσας",
    "payment_methods": "Μέθοδοι πληρωμής",
    "ai_translation": "Μετάφραση με AI",
    "ai_translation_settings": "Ρυθμίσεις",
    "ai_translation_pricing": "Τιμολόγηση"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Κείμενο προς παράλειψη",
        "add": "Προσθήκη νέου",
        "title": "Κείμενο προς παράλειψη",
        "description": "Προσθέστε ένα ή περισσότερα κείμενα προς παράλειψη",
        "ignore_case": "Παράβλεψη κεφαλαίων/μικρών"
      },
      "html_content": {
        "title": "Εφαρμογή στο html περιεχόμενο",
        "description": "Εφαρμόστε τον κανόνα σε όλο το περιεχόμενο ή διαλέξτε συγκεκριμένο CSS selector",
        "all_page": "Όλη η σελίδα",
        "css_selector": "Επιλογέας CSS",
        "label": "Επιλογέας CSS",
        "placeholder": "Selector προς εφαρμογή",
        "add": "Προσθήκη νέου"
      },
      "apply_to_urls": {
        "title": "Εφαρμογή σε διευθύνσεις URL",
        "description": "Επιλέξτε συγκεκριμένες διευθύνσεις URL στις οποίες θέλετε να εφαρμοστεί ο κανόνας",
        "all_urls": "Όλες οι διευθύνσεις URL",
        "selected_urls": "Επιλεγμένες διευθύνσεις URL",
        "label": "Διεύθυνση URL για εφαρμογή",
        "placeholder": "Διεύθυνση URL για εφαρμογή",
        "original_url": "Αρχικές διευθύνσεις URL",
        "translated_url": "Μεταφρασμένη διεύθυνση URL",
        "wildcard": "Χαρακτήρας υποκατάστασης",
        "regex": "Κανονική έκφραση",
        "add": "Προσθήκη νέου",
        "expression": "Τύπος έκφρασης"
      },
      "apply_urls": {
        "title_exclude": "Εξαίρεση από διευθύνσεις URL",
        "title_replace": "Αντικατάσταση σε διευθύνσεις URL",
        "title_description": "Εφαρμόστε αυτόν τον κανόνα και στη μετάφραση των διευθύνσεων URL"
      },
      "apply_languages": {
        "title": "Εφαρμογή σε γλώσσες",
        "description": "Επιλέξτε συγκεκριμένη γλώσσα στην οποία θέλετε να εφαρμοστεί ο κανόνας",
        "all_languages": "Όλες οι γλώσσες",
        "selected_languages": "Επιλεγμένες γλώσσες",
        "placeholder": "Επιλέξτε γλώσσες...",
        "feedback": "Πρέπει να επιλέξετε μια γλώσσα"
      },
      "name": {
        "title": "Τίτλος",
        "description": "Δώστε έναν τίτλο στον κανόνα σας για ευκολία",
        "placeholder": "Όνομα κανόνα"
      },
      "type": {
        "title": "Τύπος",
        "description": "Επιλέξτε τον τύπο κανόνα που θέλετε να προσθέσετε",
        "text_ignore": "Αγνόηση κειμένου",
        "text_replace": "Αντικατάσταση κειμένου",
        "content_exclusion": "Εξαίρεση περιεχομένου",
        "url_exclusion": "Εξαίρεση με βάση τη διεύθυνση URL",
        "ignore_inline": "Αγνόηση ενσωματωμένου",
        "full_description": {
          "text_ignore": "Προσθέστε κανόνες για να αποφύγετε τη μετάφραση ορισμένων κειμένων. Μπορεί να είναι το όνομα του προϊόντος σας, το όνομα της μάρκας ή άλλα τεχνικά στοιχεία που δεν θέλετε να μεταφραστούν.",
          "text_replace": "Η αντικατάσταση κειμένου σάς επιτρέπει να αντικαταστήσετε κάποιο κείμενο με τη μετάφραση που επιθυμείτε, κάτι που μπορεί να είναι απαραίτητο όταν η μετάφραση παραβλέπει το περιεχόμενο.",
          "content_exclusion": "Η εξαίρεση περιεχομένου θα σας βοηθήσει να αποφύγετε τη μετάφραση ορισμένου περιεχομένου στη σελίδα.\nΑν θέλετε να εξαιρέσετε πλήρως μια σελίδα από τη μετάφραση (καθόλου πολύγλωσση διεύθυνση URL για αυτή τη σελίδα και καθόλου μεταφρασμένο περιεχόμενο), χρησιμοποιήστε τον τύπο \"Εξαίρεση με βάση τη διεύθυνση URL\"",
          "url_exclusion": "Η εξαίρεση μετάφρασης σελίδας θα σας βοηθήσει να ορίσετε τις σελίδες που δεν θέλετε να μεταφραστούν.",
          "ignore_inline": "Αποφύγετε τη μετάφραση ορισμένου περιεχομένου ως ενσωματωμένου, μεταφράζοντας κάθε ετικέτα ξεχωριστά."
        }
      },
      "text_replace": {
        "title": "Κείμενο προς αντικατάσταση",
        "description": "Αντικαταστήστε κάποιο κείμενο με τη συγκεκριμένη μετάφρασή σας. Αντικαταστήστε οποιοδήποτε κείμενο σε όλες τις σελίδες σας, ανά γλώσσα…",
        "text_to_replace": "Κείμενο προς αντικατάσταση",
        "ignore_case": "Αγνόηση πεζών-κεφαλαίων",
        "text_type": "Αντικατάσταση στη μετάφραση",
        "text_type_original": "Πρωτότυπο",
        "text_type_translation": "Μετάφραση",
        "keep_case": "Προσπάθεια διατήρησης πεζών-κεφαλαίων",
        "add": "Προσθήκη νέου"
      },
      "content_exclusion": {
        "title": "Εξαίρεση περιεχομένου",
        "description": "Επιλέξτε έναν ή περισσότερους επιλέκτες CSS οι οποίοι δεν θα μεταφραστούν",
        "label": "Επιλέκτης CSS",
        "placeholder": "Επιλέκτης για εφαρμογή",
        "add": "Προσθήκη νέου"
      },
      "multilingual_url": {
        "title": "Χρήση πολύγλωσσης διεύθυνσης URL",
        "description": "Αν οριστεί στο Ναι, η διεύθυνση URL ΔΕΝ θα μεταφραστεί, αλλά η σελίδα θα παραμείνει πολύγλωσση με μεταφρασμένο περιεχόμενο",
        "live_example_title": "Ζωντανό παράδειγμα",
        "live_example_description": "URL προέλευσης: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Δημιουργημένη διεύθυνση URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Δημιουργημένη διεύθυνση URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Εφαρμόστε τον κανόνα σε στατικό περιεχόμενο ή δυναμικό περιεχόμενο ή και στα δύο",
        "title": "Εφαρμογή σε περιεχόμενο",
        "all": "Όλο το περιεχόμενο",
        "static": "Στατικό περιεχόμενο",
        "dynamic": "Δυναμικό περιεχόμενο"
      },
      "force_apply_urls": {
        "title_description": "Εξαναγκασμός εφαρμογής αυτού του κανόνα σε όλες τις μεταφράσεις διευθύνσεων URL, συμπεριλαμβανομένων των υπαρχουσών!",
        "title_replace": "Εξαναγκασμός αντικατάστασης σε διευθύνσεις URL",
        "title_exclude": "Εξαναγκασμός εξαίρεσης από διευθύνσεις URL",
        "warning": "Προειδοποίηση",
        "warning_part1": "Η ρύθμιση αυτού σε \"Ναι\" ενδέχεται να διακόψει τις μεταφράσεις διευθύνσεων URL του ιστότοπού σας.",
        "warning_part2": "Αυτό μπορεί να δημιουργήσει προσωρινά ή μόνιμα σελίδες 404· συνεχίστε μόνο αν κατανοείτε τις συνέπειες.",
        "warning_replacement_original": "Πρόσθετη προειδοποίηση: Προσπαθείτε να αντικαταστήσετε αρχικό περιεχόμενο που μπορεί να επηρεάσει τη διεύθυνση URL· η μετάφραση ενδέχεται να αποτύχει καθώς το Linguise δεν μπορεί να εντοπίσει σωστά τις αρχικές διευθύνσεις URL"
      }
    },
    "main": {
      "parent": "Κανόνες",
      "edit": "Επεξεργασία κανόνα",
      "add": "Νέος κανόνας"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "Το \"{{text_ignore}}\" θα αγνοηθεί στο περιεχόμενο και στη διεύθυνση URL",
      "preview_single": "Το \"{{text_ignore}}\" θα αγνοηθεί στο περιεχόμενο",
      "preview_more_with_url": "Το \"{{text_ignore}}\" και {{count}} ακόμα θα αγνοηθούν στο περιεχόμενο",
      "preview_more": "Το \"{{text_ignore}}\" και {{count}} ακόμα θα αγνοηθούν στο περιεχόμενο",
      "other_parameters": "Έχουν οριστεί άλλες παράμετροι για αυτόν τον κανόνα· κάντε κλικ στο κουμπί επεξεργασίας για περισσότερες πληροφορίες"
    },
    "text_replace": {
      "preview_single_with_url": "Το \"{{original}}\" αντικαθίσταται από το \"{{replacement}}\" στο περιεχόμενο και στις διευθύνσεις URL",
      "preview_single": "Το \"{{original}}\" αντικαθίσταται από το \"{{replacement}}\" στο περιεχόμενο",
      "preview_more_with_url": "Το \"{{original}}\" αντικαθίσταται από το \"{{replacement}}\" στο περιεχόμενο και στις διευθύνσεις URL, και {{nb}} ακόμα",
      "preview_more": "Το \"{{original}}\" αντικαθίσταται από το \"{{replacement}}\" στο περιεχόμενο, και {{nb}} ακόμα",
      "other_parameters": "Έχουν οριστεί άλλες παράμετροι για αυτόν τον κανόνα· κάντε κλικ στο κουμπί επεξεργασίας για περισσότερες πληροφορίες"
    },
    "content_exclusion": {
      "selectors": "{{nb}} επιλέκτη(ες) CSS εξαιρούνται από τη μετάφραση",
      "other_parameters": "Έχουν οριστεί άλλες παράμετροι για αυτόν τον κανόνα· κάντε κλικ στο κουμπί επεξεργασίας για περισσότερες πληροφορίες"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} διευθύνσεις URL εξαιρούνται από τη μετάφραση, αλλά διατηρούν το πολύγλωσσο πρόθεμα",
      "some": "{{nb}} διευθύνσεις URL εξαιρούνται πλήρως από τη μετάφραση",
      "all_multilingual": "Όλες οι διευθύνσεις URL εξαιρούνται από τη μετάφραση, αλλά διατηρούν το πολύγλωσσο πρόθεμα",
      "all": "Όλες οι διευθύνσεις URL εξαιρούνται πλήρως από τη μετάφραση",
      "other_parameters": "Έχουν οριστεί άλλες παράμετροι για αυτόν τον κανόνα· κάντε κλικ στο κουμπί επεξεργασίας για περισσότερες πληροφορίες"
    },
    "ignore_inline": {
      "elements": "Όλο το ενσωματωμένο περιεχόμενο θα μεταφραστεί ως περιεχόμενο μπλοκ στη σελίδα",
      "all_elements": "Κάποιο ενσωματωμένο περιεχόμενο θα μεταφραστεί ως περιεχόμενο μπλοκ στη σελίδα",
      "other_parameters": "Έχουν οριστεί και άλλες παράμετροι για αυτόν τον κανόνα, κάντε κλικ στο κουμπί επεξεργασίας για να λάβετε περισσότερες πληροφορίες."
    },
    "title": "Διαχείριση κανόνων",
    "description": "Διαχειριστείτε τις εξαιρέσεις και αντικαταστάσεις περιεχομένου μετάφρασης σε όλο τον ιστότοπό σας",
    "add": "Προσθήκη νέου κανόνα",
    "table": {
      "title": "Τίτλος",
      "no_data": "Δεν υπάρχουν κανόνες ακόμα",
      "type": "Τύπος",
      "preview": "Προεπισκόπηση κανόνα",
      "action": "Ενέργεια",
      "delete_confirm": "Παρακαλούμε επιβεβαιώστε τη διαγραφή του κανόνα",
      "types": {
        "text_ignore": "Αγνόηση κειμένου",
        "text_replace": "Αντικατάσταση κειμένου",
        "content_exclusion": "Αποκλεισμός περιεχομένου",
        "url_exclusion": "Αποκλεισμός URL",
        "ignore_inline": "Αγνόηση inline",
        "unknown": "Άγνωστος κανόνας"
      }
    },
    "apply_on_content": {
      "static": "Αυτός ο κανόνας θα εφαρμόζεται μόνο σε στατικό περιεχόμενο",
      "dynamic": "Αυτός ο κανόνας θα εφαρμόζεται μόνο σε δυναμικό περιεχόμενο"
    }
  },
  "search_translations": {
    "title": "Διαχείριση αναζητήσεων",
    "description": "Λίστα όλων των μεταφράσεων της ιστοσελίδας σας που χρησιμοποιούνται μέσω φορμών αναζήτησης (από μεταφρασμένη γλώσσα στη βασική γλώσσα του τομέα σας)",
    "filter_languages": "Φιλτράρισμα ανά γλώσσες...",
    "filter_original": "Φιλτράρισμα κειμένου στην αρχική γλώσσα",
    "filter_translation": "Φιλτράρισμα ανά μεταφρασμένο κείμενο",
    "table": {
      "original": "Πρωτότυπο",
      "language": "Γλώσσα",
      "translation": "Μετάφραση"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Η συνδρομή απέτυχε!",
      "title": "Η συνδρομή απέτυχε!",
      "subtitle": "Παρουσιάστηκε σφάλμα κατά την επεξεργασία της συνδρομής σας.",
      "home": "Επιστροφή στην αρχική",
      "generic": "Προέκυψε άγνωστο σφάλμα από το Linguise· επικοινωνήστε με τον διαχειριστή!"
    },
    "success": {
      "home": "Διαχείριση μεταφράσεων τομέα",
      "message": "Δεσμευόμαστε να σας παρέχουμε την καλύτερη δυνατή εμπειρία μετάφρασης. Η ομάδα ειδικών μας είναι διαθέσιμη για οποιαδήποτε απορία ή υποστήριξη. Απλώς πατήστε το παρακάτω κουμπί για να ξεκινήσετε.",
      "subtitle": "Σας ευχαριστούμε που επιλέξατε την υπηρεσία μετάφρασης Linguise",
      "title": "Η συνδρομή ενεργοποιήθηκε!",
      "tab_title": "Ευχαριστούμε για τη συνδρομή!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Η συνδρομή ενεργοποιήθηκε!",
      "title": "Η συνδρομή ενεργοποιήθηκε!",
      "subtitle": "Σας ευχαριστούμε που επιλέξατε την υπηρεσία μετάφρασης Linguise",
      "message": "Δεσμευόμαστε να σας παρέχουμε την καλύτερη δυνατή εμπειρία μετάφρασης. Η ομάδα ειδικών μας είναι διαθέσιμη για οποιαδήποτε απορία ή υποστήριξη. Απλώς πατήστε το παρακάτω κουμπί για να ξεκινήσετε.",
      "home": "Διαχείριση μεταφράσεων τομέα"
    },
    "edit": {
      "title": "Διαχείριση συνδρομής"
    },
    "list": {
      "title": "Λίστα συνδρομών",
      "description": "Λίστα των συνδρομών του τομέα σας"
    },
    "table": {
      "domain": "Τομέας",
      "plan": "Πρόγραμμα",
      "status": "Κατάσταση",
      "card": "Κάρτα",
      "usage": "Χρήση",
      "actions": "Ενέργειες",
      "payment_method": "Τρόπος Πληρωμής"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} λέξεις",
      "paidOffered": "{{words_used}} / {{words_allowed}} λέξεις\n(Συμπεριλαμβάνονται {{free_words}} δωρεάν λέξεις)"
    },
    "popup": {
      "dueToday": "Συνολικά ληξιπρόθεσμα σήμερα",
      "nextPeriod": "Ξεκινώντας από {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Επιλέξτε λογαριασμό"
    }
  },
  "translation": {
    "main": {
      "parent": "Μεταφράσεις",
      "edit": "Επεξεργασία μετάφρασης"
    },
    "form": {
      "original": {
        "title": "Πρωτότυπο στα {{language}}"
      },
      "is_inline": "Αυτή η μετάφραση έχει γίνει από inline περιεχόμενο.",
      "inline_editor": {
        "count_warning": "Ο αριθμός των ενσωματωμένων περιοχών δεν συμφωνεί με το πρωτότυπο ({{current}} από {{expected}}).",
        "restore_original": "Επαναφορά αρχικού κειμένου",
        "insert_placeholder": "Εισαγωγή placeholder",
        "drag": "Σύρετε για να αλλάξετε τη σειρά της περιοχής",
        "area": "Ενσωματωμένη περιοχή {{index}}",
        "restore": "Επαναφορά περιοχών που λείπουν"
      },
      "translation": {
        "title": "Μετάφραση στα {{language}}",
        "description": "Μετάφραση που θέλετε να αντικαταστήσετε"
      }
    },
    "copy": {
      "title": "Αντιγραφή στη χειροκίνητη μετάφραση",
      "label": "Αντιγραφή στη χειροκίνητη"
    },
    "level": {
      "base": {
        "title": "Βασική μετάφραση",
        "subtitle": "Αυτόματη · μετάφραση Linguise Cloud",
        "empty": "Δεν υπάρχει βασική μετάφραση για αυτό το κείμενο.",
        "overridden": "Η επιλογή σας έχει αποθηκευτεί, αλλά εμφανίζεται αντ' αυτής η πιο πρόσφατη βελτιωμένη μετάφραση AI, επειδή η ρύθμιση «Αντικατάσταση χειροκίνητων και επιλεγμένων μεταφράσεων» είναι «Ναι» στις ρυθμίσεις μετάφρασης AI. Απενεργοποιήστε τη ρύθμιση για να χρησιμοποιηθεί η επιλογή σας."
      },
      "not_generated": "Δεν έχει δημιουργηθεί",
      "none": "Καμία ακόμη",
      "ai": {
        "title": "Βελτιωμένη μετάφραση AI",
        "subtitle": "Αυτόματη · Linguise AI",
        "empty_title": "Δεν έχει δημιουργηθεί ακόμη για αυτό το κείμενο",
        "empty_description": "Το Linguise AI δίνει πιο φυσικές μεταφράσεις χρησιμοποιώντας το περιεχόμενο της σελίδας και του ιστότοπού σας. Για να αποκτήσετε μία εδώ:",
        "empty_step_1": "Μεταβείτε στο Μετάφραση AI › Ρυθμίσεις και ορίστε το Ενεργοποίηση μετάφρασης AI σε «Μόνο κανόνες», «Μόνο live editor» ή «Κανόνες και live editor».",
        "empty_step_2": "Εφαρμόστε την με έναν κανόνα που ταιριάζει σε αυτή τη σελίδα ή ενεργοποιήστε την σελίδα προς σελίδα από το live editor.",
        "empty_step_3": "Η βελτιωμένη μετάφραση AI θα εμφανιστεί εδώ μόλις δημιουργηθεί. Χρησιμοποιεί τα credits AI σας.",
        "open_settings": "Άνοιγμα ρυθμίσεων μετάφρασης AI",
        "open_editor": "Άνοιγμα live editor",
        "overrides_selection": "Η επιλογή σας έχει αποθηκευτεί, αλλά εμφανίζεται αντ' αυτής αυτή η βελτιωμένη μετάφραση AI, επειδή η ρύθμιση «Αντικατάσταση χειροκίνητων και επιλεγμένων μεταφράσεων» είναι «Ναι» στις ρυθμίσεις μετάφρασης AI. Απενεργοποιήστε τη ρύθμιση για να χρησιμοποιηθεί η επιλογή σας.",
        "overrides_version": "Η έκδοση που επιλέξατε έχει αποθηκευτεί, αλλά εμφανίζεται αντ' αυτής η πιο πρόσφατη βελτιωμένη έκδοση AI, επειδή η ρύθμιση «Αντικατάσταση χειροκίνητων και επιλεγμένων μεταφράσεων» είναι «Ναι» στις ρυθμίσεις μετάφρασης AI. Απενεργοποιήστε τη ρύθμιση για να χρησιμοποιηθεί η επιλεγμένη έκδοση."
      },
      "manual": {
        "title": "Χειροκίνητη μετάφραση",
        "subtitle": "Γραμμένη από εσάς · έχει προτεραιότητα έναντι των αυτόματων μεταφράσεων",
        "empty": "Κενή",
        "saved_but_overridden": "Αποθηκεύτηκε ως επιλογή σας, αλλά δεν εμφανίζεται αυτόματα επειδή η ρύθμιση «Αντικατάσταση χειροκίνητων μεταφράσεων» είναι «Ναι» στις ρυθμίσεις μετάφρασης AI: η βελτιωμένη μετάφραση AI υπερισχύει μέχρι να απενεργοποιηθεί αυτή η ρύθμιση.",
        "ignored": "Δεν εμφανίζεται αυτόματα επειδή η ρύθμιση «Αντικατάσταση χειροκίνητων μεταφράσεων» είναι «Ναι» στις ρυθμίσεις μετάφρασης AI. Επιλέξτε την για να τη χρησιμοποιήσετε για αυτό το κείμενο.",
        "label": "Η μετάφρασή σας",
        "placeholder": "Πληκτρολογήστε τη δική σας μετάφραση...",
        "last_updated": "Τελευταία επεξεργασία {{date}}",
        "save_hint": "Η αποθήκευση μιας χειροκίνητης μετάφρασης την ενεργοποιεί.",
        "delete": "Διαγραφή χειροκίνητης μετάφρασης",
        "delete_confirm": "Επιβεβαιώστε τη διαγραφή της χειροκίνητης μετάφρασης"
      }
    },
    "history": {
      "title": "Βελτιωμένες εκδόσεις AI",
      "subtitle": "Κάθε αναδημιουργία από το live editor διατηρείται",
      "unknown_model": "Άγνωστο μοντέλο",
      "current": "Τρέχουσα",
      "restore": "Επαναφορά αυτής της έκδοσης",
      "restore_note": "Η επαναφορά κάνει αυτή την έκδοση την τρέχουσα βελτιωμένη μετάφραση AI. Τίποτα δεν διαγράφεται.",
      "version_of": "Έκδοση {{current}} από {{total}}",
      "hide": "Απόκρυψη ιστορικού ({{total}})",
      "show": "Εμφάνιση ιστορικού ({{total}})"
    },
    "choose": {
      "title": "Μεταφράσεις στα {{language}} · επιλέξτε ποια βλέπουν οι επισκέπτες",
      "current": "Αυτή τη στιγμή στον ιστότοπό σας:",
      "priority": "Προεπιλεγμένη προτεραιότητα: Χειροκίνητη › Βελτιωμένη AI › Βασική. Η επιλογή σας αποθηκεύεται μόνο για αυτή τη μετάφραση.",
      "reset": "Επαναφορά στην προεπιλεγμένη προτεραιότητα",
      "reset_title": "Παράβλεψη της επιλογής σας για αυτό το κείμενο και χρήση ξανά της προεπιλεγμένης προτεραιότητας",
      "resetting": "Επαναφορά ..."
    }
  },
  "translations": {
    "title": "Διαχείριση μεταφράσεων",
    "description": "Λίστα και επεξεργασία όλων των μεταφράσεων της ιστοσελίδας σας· για οπτική μετάφραση χρησιμοποιήστε τον Live Editor",
    "filter_languages": "Φιλτράρισμα ανά γλώσσες...",
    "filter_original": "Φιλτράρισμα κειμένου στην αρχική γλώσσα",
    "filter_translation": "Φιλτράρισμα ανά μεταφρασμένο κείμενο",
    "table": {
      "original": "Πρωτότυπο",
      "language": "Γλώσσα",
      "action": "Ενέργεια",
      "base": "Βασική",
      "ai": "Βελτιωμένη AI",
      "manual": "Χειροκίνητη"
    },
    "filter_exact": "Ακριβής αντιστοιχία",
    "badge": {
      "active": "Ενεργή",
      "overrides_manual": "Αντικαθιστά χειροκίνητη"
    },
    "cell": {
      "none": "καμία",
      "not_generated": "δεν έχει δημιουργηθεί",
      "ignored": "Αγνοείται – υπερισχύει ο κανόνας AI"
    },
    "tabs": {
      "all": "Όλες",
      "manual": "Με χειροκίνητη",
      "ai": "Με βελτιωμένη AI",
      "base": "Μόνο βασική"
    },
    "levels_hint": "Κάθε κείμενο έχει έως 3 επίπεδα – αυτό που επισημαίνεται ως Ενεργή είναι αυτό που βλέπουν οι επισκέπτες."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Επεξεργασία μετάφρασης URL"
    },
    "form": {
      "original": {
        "title": "Πρωτότυπο στα {{language}}"
      },
      "translation": {
        "title": "Μετάφραση URL στα {{language}}",
        "description": "URL που θέλετε να αντικαταστήσετε",
        "placeholder": "Αντικατάσταση μετάφρασης URL",
        "invalid_full": "Προσπαθείτε να αλλάξετε με λανθασμένη μορφή· πρέπει να αλλάξετε μόνο τα slugs/pathname της μετάφρασης URL",
        "invalid": "Μη έγκυρο URL/διαδρομή"
      }
    }
  },
  "urls": {
    "title": "Διαχείριση URLs",
    "description": "Λίστα και επεξεργασία όλων των μεταφρασμένων περιεχομένων URL της ιστοσελίδας σας (προχωρημένο, προσέξτε τα σφάλματα 404)",
    "filter_languages": "Φιλτράρισμα ανά γλώσσες...",
    "filter_original": "Φιλτράρισμα κειμένου στην αρχική γλώσσα",
    "filter_translation": "Φιλτράρισμα ανά μεταφρασμένο κείμενο",
    "table": {
      "original": "Πρωτότυπο",
      "language": "Γλώσσα",
      "url": "Μεταφρασμένο URL",
      "action": "Ενέργεια",
      "edited": "Η αρχική μετάφραση έχει επεξεργαστεί"
    }
  }
}
